import { Language } from 'app/model/constant';
export const LANG_EN_NAME = Language.en;

export const LANG_EN_TRANS = {
  'hello world': 'hello world',
  'menu-bar-home': 'Home',
  'menu-bar-account': 'My Account',
  'menu-bar-profile': 'Profile',
  'menu-bar-booking': 'Booking',
  'menu-bar-approval': 'Approval',
  'menu-bar-my-budget': 'User permission & budget',
  'menu-bar-fleet-card': 'Fleet card',
  'menu-bar-setting-account': 'Account Security',
  'menu-bar-login': 'Register/Login',
  'menu-bar-logout': 'Log out',
  'menu-bar-baht': 'THB',
  'menu-bar-baht-opposite': 'บาท',
  'menu-bar-baht-accommodation': 'Accommodations',
  'menu-bar-baht-business-events': 'Corporate group / Event',
  'menu-bar-co-working-space': 'Co-working space',
  'menu-bar-flight': 'Flight',
  'menu-bar-car-rental': 'Car Rental',
  'menu-bar-help': 'Help',
  'menu-bar-language': 'Language',
  'menu-bar-language-choice-en': 'English',
  'menu-bar-language-choice-th': 'Thai',
  'menu-bar-currency': 'Currency',
  'menu-bar-switch-company': 'Company',
  'menu-bar-setting': 'Settings',
  'menu-bar-pre-approval-requests': 'Pre-Approval Request',
  'menu-bar-pre-approval-approvals': 'Approval Requests',

  'switch-language-title': 'Language',
  'switch-currency-title': 'Currency',
  'switch-language-currency-title': 'Language and Currency',
  'switch-language-currency-sub-title': 'The system will convert and display the price in the currency you selected. The currency in which you pay may vary depending on your booking. There may also be a service charge.',

  'btn-register': 'Register',
  'btn-joinus': 'Join Us',
  'btn-cancel': 'Cancel',
  'btn-clear': 'Clear',
  'btn-choose': 'Choose',
  'btn-go-to-booking': 'Go to my booking',
  'btn-export': 'Export',
  'btn-clear-selection': 'Clear Selection',
  'btn-clear-selection-mb': 'Cancel',
  'btn-confirm': 'Confirm',
  'btn-close': 'Close',
  'btn-submit': 'Confirm',

  'link-view-map': 'View map',
  'map-marker-room-not-available': 'Unavailable',

  'footer-company-name': 'Ascend Travel Co.,Ltd. (Head Office)',
  'footer-address-01': 'AIA Capital Center Building,',
  'footer-address-02': '18-19 Floor, 89 Ratchadaphisek Road,',
  'footer-address-03': 'Dindaeng, Dindaeng, Bangkok 10400',
  'footer-new-address-01': 'No. 101 True Digital Park, Griffin Building, 12A Floor,',
  'footer-new-address-02': 'Sukhumvit Road, Bangchak Sub-District,',
  'footer-new-address-03': 'Phra Khanong District, Bangkok 10260, Thailand',
  'footer-license': 'TAT License : 11/08384',
  'footer-call-center': 'Call Center',
  'footer-customer-support': 'Customer Support',
  'footer-customer-help': 'Help',
  'footer-customer-terms': 'Terms of Use',
  'footer-customer-terms-02': 'Privacy Policy',
  'footer-customer-cookies': 'Cookies Policy',


  'province-hauhin': 'HAU HIN / CHA AM',
  'province-pattaya': 'PATTAYA',
  'province-chiang-mai': 'CHIANG MAI',
  'province-phuket': 'PHUKET',
  'province-krabi': 'KRABI',
  'province-koh-samui': 'KOH SAMUI',
  'province-bangkok': 'BANGKOK',
  'province-khao-lak': 'KHAO LAK',
  'province-koh-chang': 'KOH CHANG',
  'province-kanchanaburi': 'KANCHANABURI',


  'search-top-destination': 'Top Destinations',
  'search-top-destination-sub': 'Discover new, inspiring places around your favorite destinations.',

  'search-box-title': 'Search and Book Hotels',
  'search-box-title-sub': 'All your business travel & personal trip in one place.',
  'search-box-topic-travel': 'Leisure',
  'search-box-topic-work': 'Work',
  'search-box-tooltip-title': 'What’s the difference ?',
  'search-box-tooltip-travel': 'Search properties for your vocation. Your booking will not link to your company account.',
  'search-box-tooltip-work': 'Easy to search properties for your business trip.',
  'search-box-topic-title': 'Travelling for',
  'search-box-want': 'Where would you like to go?',
  'search-box-want-placeholder': 'Enter your destination or hotel name',
  'search-box-check-in': 'Check-in',
  'search-box-check-in-calendar': 'Check-in Date',
  'search-box-check-out': 'Check-out',
  'search-box-check-out-calendar': 'Check-out Date',
  'search-box-room': 'Room',
  'search-box-guest': 'Guest',
  'search-box-btn-search': 'Search',
  'search-box-destination': 'Destination',
  'search-box-props': 'props',
  'search-box-hotel': 'Properties/Hotels',
  'search-box-result-search': 'Search Result',
  'search-box-recent-searches': 'Recent Searches',
  'search-box-near-by': 'Nearby location',
  'search-box-near-by-you': 'Accommodation nearby',
  'your-location': 'your location',
  'location-not-found': 'Location could not be found',
  'location-message-not-found': 'Please allowing site to know your location before search accommodation nearby',
  'enter': 'OK',
  'search-box-room-in-choose': 'Room',
  'search-box-adult': 'Adult',
  'search-box-guest-count': 'Room & Guest',
  'search-box-child': 'Child',
  'search-box-children': 'Children',
  'search-box-child-age': 'Children\'s ages (years)',
  'search-box-person': 'person',
  'search-box-want-read': 'Your Destination',
  'search-box-check-in-out-read': 'Period of stay',
  'search-box-guest-read': 'Room & Guest',
  'search-box-btn-cancel-change': 'Cancel',
  'search-box-btn-change': 'Change',
  'search-box-point_of_interest': 'Point of Interest',

  'search-box-over-budget-checkbox-label': 'I want to see all properties without budget limit.',
  'search-box-over-budget-hover-info-label': 'You can book and pay for the exceeding amount of your budget.',
  'search-box-over-budget-hover-credit-card-label': 'personal credit/debit card',

  'search-box-error-purpose': 'Please choose your travel objective.',
  'search-box-error-destination': 'Please enter destination or hotel that you interested.',
  'search-box-error-work-1-room': 'Reservation for work can be booked only 1 room and maximum 2 guests at a time.',
  'search-box-error-work-2-person': 'Reservation for work can be booked maximum 2 guests per room.',
  'search-box-error-work-no-child': 'Reservation for work cannot be booked with children.',
  'search-box-error-feature-not-allow': 'due to your company or co-booker company not allow to share budget.',
  'search-box-error-code-ref-expired': 'due to share budget code is expired.',
  'search-box-error-code-ref-incorrect': 'due to share budget code is incorrect.',

  'search-box-budget-per-night': 'Your budget limit is <strong>{currency} {budget}</strong> /room/night.',
  'search-box-budget-per-month': 'You have budget <strong>{currency} {budgetPerMonth}</strong> /month.',
  'search-box-budget-per-year': 'You have budget <strong>{currency} {budgetPerYear}</strong> /year.',
  'search-box-budget-per-month-per-year': 'You have budget <strong>{currency} {budgetPerMonth}</strong> /month and <strong>{currency} {budgetPerYear}</strong> /year.',
  'search-box-budget-unlimited': 'Your budget/room/night is unlimited.',
  'search-box-new-budget-per-night': 'Your new budget limit is <strong>{currency} {budget}</strong> /room/night.',
  'search-box-new-budget-unlimited': 'Your new budget/room/night is unlimited.',
  'search-box-see-all-my-budget': 'View budget details',
  'search-box-share-budget': 'Share budget',
  'search-box-share-budget-tooltips': 'You can book and share budget with your co-booker.',
  'search-box-cancel-share-budget': 'Cancel share budget',
  'budget-unlimited': 'Unlimited',
  'search-box-tooltips-share-budget-detail-title': 'You have shared budget with co-booker',
  'search-box-tooltips-share-budget-detail-booker-budget': 'Your budget',
  'search-box-tooltips-share-budget-detail-co-booker-budget': 'Your co-booker budget',
  'search-box-tooltips-share-budget-detail-total-budget': 'Total budget/room/night',
  'search-box-tooltips-share-budget-detail-apply-co-budget': 'There is a budget limit for booking with 2 guests.',


  'account-menu-bar-profile': 'Profile',
  'account-menu-bar-share-budget-code': 'Share budget code',
  'account-menu-bar-my-budget': 'User permission & budget',
  'account-menu-bar-fleet-card': 'Fleet Card',
  'account-menu-bar-account-security': 'Account Security',
  'account-menu-bar-logout': 'Logout',

  'account-change-password-headline': 'Change Password',
  'account-change-password-title': 'Change Password',
  'account-change-password-new': 'New Password',
  'account-change-password-new-fill': 'Enter your new password here',
  'account-change-password-confirmation': 'Confirm Password',
  'account-change-password-confirmation-fill': 'Enter your new password again',
  'account-change-password-button-submit': 'Save',
  'account-change-password-button-cancel': 'Cancel',
  'account-change-password-validation-text': 'The password must include',
  'account-change-password-validation-length-text': 'Length of 8-16 characters which included alphabetic characters, numeric characters or special character such as @ $ ! % * # ? &',
  'account-change-password-validation-uppercase-text': 'At least one uppercase letter',
  'account-change-password-validation-lowercase-text': 'At least one lowercase letter',
  'account-change-password-validation-numeric-text': 'At least one numeric characters',

  'account-security-title': 'Account Security',
  'account-security-email': 'Email',
  'account-security-email-description': 'This email is used for login and we use this email to send you booking details.',
  'account-security-password': 'Password',
  'account-security-password-description': 'Regularly changing your password helps keep your account protected.',
  'account-security-password-action': 'Change Password',
  'account-security-phone': 'Phone',
  'account-security-phone-action': 'Change Phone',
  'account-security-new-phone-action': 'Binding Phone',
  'account-security-pin': 'PIN Code',
  'account-security-pin-description': 'Use PIN code for credit terms payment processing to your company.',
  'account-security-pin-action': 'Set PIN',

  'booking-my-booking': 'Booking',
  'booking-my-booking-list': 'All',
  'booking-my-booking-from': 'From',
  'booking-my-booking-from2': 'From',
  'booking-my-booking-until': 'Until',
  'booking-my-booking-until2': 'Until',
  'booking-my-booking-before': 'Before',
  'booking-my-booking-id': 'Booking ID',
  'booking-my-booking-booking-date': 'Booking Date / Time',
  'booking-my-booking-payment-date': 'Pay on',
  'booking-my-booking-booker-cancel-date': 'by booker on',
  'booking-my-booking-booker-cancel-booker-date': 'by main booker on',
  'booking-my-booking-booker-cancel-co-booker-date': 'by co-booker on',
  'booking-my-booking-booker-cancel-name-date': 'by {name} on',
  'booking-my-booking-booker-reject-supervisor-date': ' by supervisor (main booker) on',
  'booking-my-booking-booker-reject-co-supervisor-date': 'by supervisor (co-booker) on',
  'booking-my-booking-checkin': 'Check-in',
  'booking-my-booking-checkout': 'Check-out',
  'booking-my-booking-approved-date': 'Approved date',
  'booking-my-booking-rejected-date': 'by supervisor on',
  'booking-my-booking-re-booking': 'Re-Booking',
  'booking-my-booking-sumbit': 'Booking',
  'booking-my-booking-btn-details': 'Booking details',
  'booking-my-booking-cancel': 'Cancel booking',
  'booking-my-booking-map': 'View map',
  'booking-my-booking-review': 'Review your stay',
  'booking-my-booking-review-published': 'Review published',
  'booking-my-booking-previous': 'Previous',
  'booking-my-booking-next': 'Next',
  'booking-my-booking-arranged-by': 'Sort By',
  'booking-my-booking-arranged-by-mobile': 'By',
  'booking-my-booking-all': 'All',
  'booking-my-booking-search-text': 'Booking ID',
  'booking-my-booking-search-not-found': 'Cannot found this Booking ID',
  'booking-my-booking-text-booking-date': 'Booking date/time',
  'booking-my-booking-text-total-room': 'No. of room',
  'booking-my-room': 'room',
  'booking-my-night': 'Night',
  'booking-my-guest': 'Guest',
  'booking-my-booking-text-total-max-guest': 'No. of guest',
  'booking-my-adult': 'adult',
  'booking-my-child': 'child',
  'booking-my-children': 'children',
  'booking-my-status-success-booking': 'Booking successful',
  'booking-my-status-successfully-payment': 'Payment successful',
  'booking-my-status-success-payment': 'Payment successful',
  'booking-my-status-failure-payment': 'Payment failed',
  'booking-my-status-cancelled-booking': 'Booking cancelled',
  'booking-my-status-inprogress': 'On process',
  'booking-my-status-already-checkout': 'Depart',
  'booking-my-status-failure-booking': 'Booking failed',
  'booking-my-status-awaiting-approval': 'Booked and awaiting approval',
  'booking-my-status-booking-approved': 'Booked and approved successful',
  'booking-my-status-booking-rejected': 'Rejected',
  'booking-my-booking-filter-by': 'Filter',
  'booking-my-booking-filter-by-all': 'All',
  'booking-my-booking-filter-by-upcoming': 'Upcoming',
  'booking-my-booking-filter-by-check-in': 'During Stay',
  'booking-my-booking-filter-by-completed': 'Completed',
  'booking-my-booking-filter-by-cancelled': 'Cancelled',
  'booking-my-booking-filter-by-failed': 'Failed',
  'booking-my-booking-sort-by-booking-date': 'Booking date',
  'booking-my-booking-sort-by-checkin-date': 'Check-in date',
  'booking-my-booking-sort-by-payment-date': 'Payment date',

  // Approval List
  'approval-list': 'Approval',
  'approval-list-search-text': 'Search by Booking ID',
  'approval-list-search-not-found': 'Cannot found this Booking ID',
  'approval-list-search-empty': 'No Booking',
  'approval-list-filter-by': 'Filter',
  'approval-list-sort-by': 'Sort by',
  'approval-list-filter-by-all': 'All',
  'approval-list-filter-by-waiting': 'Waiting',
  'approval-list-filter-by-approved': 'Approved',
  'approval-list-filter-by-cancelled': 'Cancelled',
  'approval-list-sort-by-booking-date': 'Booking date',
  'approval-list-sort-by-checkin-date': 'Check-in date',
  'approval-list-requester-name': 'Requester name',
  'approval-list-booking-id': 'Booking ID',
  'approval-list-grand-total': 'Total price',
  'approval-list-button-detail': 'Booking details',
  'approval-list-status-approved': 'Approved',
  'approval-list-status-booker-cancelled': 'Booking cancelled',
  'approval-list-status-last-minute1': 'Cannot approve or reject reservation',
  'approval-list-status-last-minute2': 'because it booked on check-in date.',
  'approval-list-status-no-action': 'Booking Successful without Approval',
  'approval-list-status-rejected': 'Rejected',
  'approval-list-approved-date': 'Approved date',
  'approval-list-rejected-date': 'Rejected date',
  'approval-list-cancel-date': 'Cancelled date',
  'approval-message-approve-success': 'Reservation has been approved and processed successfully.',
  'approval-message-approve-fail': 'Process is not successful. Please try again.',
  'approval-message-reject-success': 'Rejected reservation successfully.',
  'approval-message-reject-fail': 'Process is not successful. Please try again.',

  'approval-button-reject': 'Reject',
  'approval-button-approve': 'Approve',

  'approval-details-btn-back': 'Back to approval',
  'approval-details-contact-number': ' Contact number',


  // Payment Summary
  'payment-summary-cancel-header': 'Booking cancelled',
  'payment-summary-reject-header': 'Booking rejected',

  'payment-summary-exclude-vat': 'Price (Excluding VAT)',
  'payment-summary-vat': 'VAT 7% ',
  'payment-summary-before-discount': 'Total before discount',
  'payment-summary-promotion-code-discount': 'Promotion code discount',
  'payment-summary-book-grand-total': 'Total price',
  'payment-summary-pay-credit-term-main-booker': 'Charge to main booker',
  'payment-summary-pay-credit-term-co-booker': 'Charge to co-booker',
  'payment-summary-pay-credit-term-remark': 'Charge to credit terms',
  'payment-summary-taxes-fees': 'Taxes & Fees',
  'payment-summary-price': 'Price',

  'payment-summary-pay-credit-term': 'Pay by credit terms',
  'payment-summary-pay-credit-card': 'Pay by credit/debit card',
  'payment-summary-pay-credit-card-add': 'Pay by credit/debit card',
  'payment-summary-pay-true-money': 'Pay by TrueMoney Wallet',
  'payment-summary-pay-true-money-add': 'Pay by TrueMoney Wallet',
  'payment-summary-pay-corporate-fleet': 'Pay by corporate fleet card',
  'payment-summary-pay-personal-fleet': 'Pay by personal fleet card',
  'payment-summary-pay-personal-fleet-add': 'Pay by personal fleet card',

  'payment-summary-cancel-exclude-vat': 'Cancellation fee (Excluding VAT)',
  'payment-summary-cancel-pay-credit-term-main-booker': 'Cancellation fee charge to main booker',
  'payment-summary-cancel-pay-credit-term-co-booker': 'Cancellation fee charge to co-booker',
  'payment-summary-cancel-pay-credit-term': 'Charge to credit terms',
  'payment-summary-cancel-pay-credit-card': 'Charge to credit/debit card',
  'payment-summary-cancel-pay-true-money': 'Charge to TrueMoney Wallet',
  'payment-summary-cancel-pay-corporate-fleet': 'Charge to corporate fleet card',
  'payment-summary-cancel-pay-personal-fleet': 'Charge to personal fleet card',
  'payment-summary-cancel-total-price': 'Total price',
  'payment-summary-cancel-total-cancellation-fee': 'Total cancellation fee',
  'payment-summary-cancel-grand-total-cancellation-fee': 'Total cancellation fee',
  'payment-summary-cancel-grand-desc-main-booker': 'Charge to main booker credit terms',
  'payment-summary-cancel-grand-desc-co-booker': 'Charge to co-booker credit terms',

  'payment-summary-cancel-credit-card-refund': 'Credit/debit card refund',
  'payment-summary-cancel-true-money-refund': 'TrueMoney Wallet refund',
  'payment-summary-cancel-corporate-fleet-refund': 'Coporate fleet card refund',
  'payment-summary-cancel-personal-fleet-refund': 'Personal fleet card refund',

  'payment-summary-refund': 'Refund',
  'payment-summary-booker': 'Main booker',
  'payment-summary-co-booker': 'Co-booker',

  // Global form
  'landing-form-password-hint': 'Password must be A-Z or a-z or 0-9 or Special Charactors except single-quote(\'), double-quote("), comma(,) and back-slash(\\) 8-16 digits.',

  // Create account form
  'landing-form-create-account-select': 'Choose your main company',
  'landing-form-create-account-terms-and-conditions': 'Terms of Service and Privacy Note',
  'landing-form-create-account-accept': 'I accept',

  // Verify account form
  'landing-form-verify-account-title': 'Please enter your corporate email',
  'landing-form-verify-account-enroll': 'Not sure that your company already enrolled with Ascend Travel',
  'landing-form-confirm-email-title': 'Please check your mailbox',
  'landing-form-confirm-email-description': 'We have sent email to <br/><span class="color-main">[email]</span><br/>Check your mailbox to complete your registration<br/>within 30 mins after receive a mailbox.<br/>*If you cannot find, please check in your junk mail.</p>',
  'landing-form-confirm-email-footer': 'If you didn\'t receive your verification email. Click',
  'landing-form-confirm-email-success-description': 'We have sent email to<br/><span class="color-main">[email]</span><br/>Check your mailbox to complete your registration.<br/>*If you cannot find, please check in your junk mail.</p>',
  'landing-form-confirm-email-success-footer': 'We have sent an email for verification. If you didn\'t receive your verification email. Click',
  'landing-form-verify-email-failure-description': 'We have sent email to<br/><span class="color-main">[email]</span><br/><p>Check your mailbox to complete your registration.<br/>*If you cannot find, please check in your junk mail.</p><p>If you didn\'t receive your verification email. Click Resend verify email.</p>',
  'landing-verify-email-success': 'You have successfully verified<br/>your registration.',

  // Reset password
  'landing-form-reset-password-title': 'Reset Password',
  'landing-form-reset-password-success-title': 'Your password has been reset',
  'landing-form-reset-password-success-description': 'You can then login to your account using your new password.',
  'landing-form-reset-password-expired-title': 'Reset new password link is expired',
  'landing-form-reset-password-expired-description': 'Please click "OK" to reset new password<br/>and check your mailbox to reset new password<br/>within 30 mins after receive a mailbox.',
  'landing-form-action-link-fail-description': 'There is a system error.<br/>Please try again.',

  // Login form
  'landing-form-required-login': 'Please enter your password',
  'landing-form-forget-password': 'Forget Password ?',
  'landing-form-login-failure-title': '<p>Incorrect email or password</p>',
  'landing-form-login-failure-description': 'Please check and try it again.',
  'affiliate-form-login-title': 'Welcome to Corporate Secure Page',
  'affiliate-form-login-desc': 'Login with your organizational account.',
  'affiliate-form-login-username-required': 'Please enter your username',
  'affiliate-form-login-password-required': 'Please enter your password',
  'affiliate-form-login-button': 'Login',
  'affiliate-form-login-failure': 'Incorrect username or password. <br>Please check and try it again.',
  'affiliate-form-login-failure-cost-center-or-cost-owner-missing': 'Sorry, your cost center or cost center owner is missing! Please contact your HR. <br>True HR contact: HRIS@truecorp.co.th',
  'affiliate-form-login-failure-technical-problems': 'Login failed due to technical problems from TrueHR. Please contact your HR. <br>True HR contact: HRIS@truecorp.co.th',
  'affiliate-dialog-ok-button': 'OK',
  'error-unable-to-connect-SSO': 'Unable to connect to the SSO service. Please try again later or contact your IT support.',

  // Forgot password form
  'landing-form-forgot-password-title': 'Please enter your corporate email',
  'landing-form-forgot-password-description': 'To reset your password, enter the email you use to register with us.',
  'landing-form-forgot-password-success-title': '<p class="forget-password-title">Please check your mailbox</p>',
  'landing-form-forgot-password-success-description': 'We have sent an email to<br/><span class="color-main">[email]</span><br/>Please check your mailbox to reset new password<br/>within 30 mins after receive a mailbox.',
  'landing-form-forgot-password-fail-message': 'Request to reset new password is fail.<br/>Please click at "OK" to reset password again.',

  // Register / Join us form
  'landing-form-register-title': 'Interested to join with Ascend Travel?',
  'landing-form-register-description': 'We would like to please you but your company have not contact with us yet. If you are interested to travel with us, please leave your information. Our staff will contact you back soon.',
  'landing-form-join-us-title': 'Join with Ascend Travel',
  'landing-form-join-us-description': 'If you are interested to travel with us, please leave your information. Our staff will contact you back soon.',
  'landing-form-register-success-title': '<p>Thank you for your interest.</p>',
  'landing-form-register-success-description': 'We have already received your information.<br/>Our staff will contact you back soon.',
  'landing-form-join-us-error-title': 'Submit information failed.',
  'landing-form-join-us-error-description': 'Please contact +66(0) 2-020-2351 or Support@ascendtravel.com',
  'landing-form-register-error-title': 'Register failed.',
  'landing-form-register-error-description': 'Please contact +66(0) 2-020-2351 or Support@ascendtravel.com',

  // Verify register email
  'landing-form-verify-email-expired-title': 'Your activation link has expired',
  'landing-form-verify-email-expired-description': '<br/>We have sent an email to you again<br/>Check your mailbox to complete registration<br/>within 30 mins after receive a mailbox.<br/>*If you cannot find, please check in your junk mail.',
  'landing-form-verify-email-invalid-title': 'Link is invalid',
  'landing-form-verify-email-invalid-description': 'Please enter your email to resend verify email',

  // Login
  'landing-login-unable-get-company-feature': 'Sorry, we cannot retrieve your company information. Please contact call center for more information.<br/>Call center : +66(0) 2-020-2351',

  // Guideline
  'guideline-password': 'Create your password here',
  'guideline-confirm-password': 'Confirm your password here',
  'guideline-email': 'email@company.com',
  'guideline-name': 'Name/Surname',
  'guideline-firstname': 'Name',
  'guideline-lastname': 'Surname',
  'guideline-contact-number': '0XXXXXXXXX',
  'guideline-company': 'Company Name',
  'guideline-position': 'Your position in company',
  'guideline-company-website': 'Company Website (Optional)',
  'guideline-company-travelling-expense': 'Company Travelling Expense (Optional)',

  // Validation message
  'validation-required-name': 'Please enter your name/surname.',
  'validation-required-firstname': 'Please enter your name.',
  'validation-required-lastname': 'Please enter your surname.',
  'validation-required-full-name': 'Please enter your first name and last name.',
  'validation-required-email': 'Please enter your corporate email.',
  'validation-required-contact-number': 'Please enter your contact number.',
  'validation-required-company': 'Please enter your company name.',
  'validation-required-select-company': 'Please choose your main company.',
  'validation-required-position': 'Please enter your position in company.',
  'validation-required-accept-terms': 'Please accept terms & conditions in order to register.',
  'validation-required-password': 'Password must be A-Z or a-z or 0-9 or Special Charactors except single-quote(\'), double-quote("), comma(,) and back-slash(\\) 8-16 digits.',
  'validation-required-new-password': 'Please enter your new password.',
  'validation-required-confirm-new-password': 'Please confirm your new password.',
  'validation-previously-used-new-password': 'Please try again with a password you haven\'t used before.',
  'validation-required-title': 'Please enter Company Name or Name-Surname.',
  'validation-required-tax-number': 'Please enter Tax ID or Personal ID.',
  'validation-invalid-tax-number': 'Tax ID or Personal ID must only contain letters (a-z, A-Z), numbers (0-9).',
  'validation-required-invoice-address': 'Please enter Tax Invoice or Receipt Address.',
  'validation-required-group-select-birth-date': 'Please enter a valid date of birth.',
  'validation-pattern-email': 'Your email is incorrect. Please check and try it again',
  'validation-pattern-name': 'Name must be a-z A-Z',
  'validation-pattern-firstname': 'Name must be a-z A-Z',
  'validation-pattern-lastname': 'Surname must be a-z A-Z',
  'validation-pattern-full-name': 'Please enter guest name in English only.',
  'validation-pattern-contact-number': 'Please enter a valid phone number.',
  'validation-min-length-password': 'Password must be at between 8 - 16 characters long.',
  'validation-max-length-password': 'Password must be at between 8 - 16 characters long.',
  'validation-match-password': 'Password is not match with confirm password. Please check and try it again.',
  'validation-required-select-your-company': 'Please select company.',
  'validation-required-time-of-birth': 'Please select time of birth.',

  'btn-create-account': 'Register',
  'btn-try-again': 'Try Again',
  'btn-continue': 'Continue',
  'btn-ok': 'OK',
  'btn-login': 'Login',
  'link-resend': 'Resend verify email',
  'btn-submit-information': 'Submit information',
  'btn-request-new-password': 'Request New Password',
  'login-not-sure': 'Not sure that your company already enroll with Ascend Travel',
  'click-here': 'Click Here',
  'forget-password': 'Forget Password ?',
  'placeholder-password': 'Enter your password here',

  'my-profile-headline': 'My Profile',
  'my-profile-personal-informations': 'Personal Information',
  'my-profile-edit-profile': 'Edit Profile',
  'my-profile-name': 'Name/Surname',
  'my-profile-firstname': 'Name',
  'my-profile-lastname': 'Surname',
  'my-profile-full-name-label': 'Name/Surname',
  'my-profile-full-name-placeholder': 'Full name',
  'my-profile-member-code': 'Member No.',
  'my-profile-birthday': 'Date of birth',
  'my-profile-company-name': 'Company',
  'my-profile-nationality': 'Nationality',
  'my-profile-phone-number': 'Phone number',
  'my-profile-phone-number-placeholder': 'e.g. 0812345678',
  'my-profile-email': 'Email',
  'my-profile-working-position': 'Position',
  'my-profile-tax-invoice': 'Tax Invoice/Receipt Address',
  'my-profile-add-tax': 'Add new Tax Invoice/Receipt Information',
  'my-profile-edit': 'Edit',
  'my-profile-delete': 'Delete',
  'my-profile-edit-presonal-profile': 'Edit Personal Information',
  'my-profile-birthdate-remark': 'This information used for searching accommodations that enhance positive energy. If you wish to change your date of birth, please contact Call Center: <b>+66(0) 2-020-2351</b> / Line Official Account: <b>@AscendTravel</b>',

  'my-profile-edit-button-submit': 'Save',
  'my-profile-edit-button-cancel': 'Cancel',

  'my-profile-change-password-success-title': 'Password Reset Successful. You can use this password for next login.',
  'my-profile-change-password-success-description': '',
  'my-profile-change-password-failure-title': 'Password Reset Failed. Please try again.',
  'my-profile-change-password-failure-description': '',

  'my-profile-edit-success-title': 'Update profile successful.',
  'my-profile-edit-success-description': '',
  'my-profile-edit-failure-title': 'Update profile fail.',
  'my-profile-edit-failure-description': 'Please try again.',
  'my-profile-edit-address-failure-title': 'Update address fail.',
  'my-profile-edit-address-failure-description': 'Please try again.',

  'my-profile-address-form-tax-number': 'Tax ID',
  'my-profile-address-form-company-name': 'Company name/Name-Surname',
  'my-profile-address-form-company-name-placeholder': 'Enter Company name/Name-Surname',
  'my-profile-address-form-tax-number-id': 'Tax ID/Personal ID',
  'my-profile-address-form-tax-number-id-placeholder': 'Enter Tax ID/Personal ID',
  'my-profile-address-form-billing-address': 'Tax Invoice/​Receipt address',
  'my-profile-address-form-billing-address-placeholder': 'Enter Tax Invoice/​Receipt address',
  'my-profile-address-form-btn-cancel': 'Cancel',
  'my-profile-address-form-btn-submit': 'Submit',

  'my-profile-delete-address-success': 'Delete address success.',
  'my-profile-delete-address-failure': 'Delete address failure.',
  'my-profile-delete-address-failure-text': 'Please try agian.',
  'my-profile-confirm-msg-delete-address': 'Confirm to delete tax address?',
  'my-profile-confirm-msg-type-address': 'edit address',
  'my-profile-confirm-msg-type-profile': 'edit profile',
  'my-profile-confirm-msg': 'You have not finished {dataType} yet. Do you want to leave without finishing?',

  'my-profile-address-dialog-button-delete': 'Delete',
  'my-profile-address-dialog-button-cancel': 'Cancel',
  'my-profile-address-dialog-button-close': 'Close',

  'facility-title': 'Facilities',
  'facility-title-room': 'Room Facilities',
  'show-more-btn': 'View more',
  'show-less-btn': 'View less',
  'description-title': 'Description',
  'occupancy-policy-title': 'Occupancy policy',
  'occupancy-policy-remark-title': 'Additional Information',
  'remark': 'Remark',
  'my-profile-subscription': 'Subscription',

  // Child policy
  'child-policy-title': 'Children and extra beds',
  'child-policy-table-guest-age': `Guest's age`,
  'child-policy-table-extrabed': 'Extra bed',
  'child-policy-min-guest-age-all-age': 'All children are welcome',
  'child-policy-min-guest-age': ' Minimum age of guest is {x} year(s) ',
  'child-policy-infant-policy': 'Infant {from}-{to} year(s)',
  'child-policy-infant-description': 'Baby cot/crib available upon request',
  'child-policy-child-policy': 'Children {from}-{to} year(s)',
  'child-policy-adult-policy': 'Guests {from} years and older are considered as adults',
  'child-policy-free-stay-description': 'Stay for free if using existing bedding.',
  'child-policy-stay-description': 'Must use an extra bed.',
  'child-policy-free-description': 'Extra beds may be requested directly from the property; additional charges may apply',
  'child-policy-description': 'Must use an extra bed which will incur an additional charge.',

  // Review rating component in level-D
  'review-rating-title': 'Guest Rating',
  'review-uncommonThings-title': 'Special reviews',
  'review-uncommonThings-title-right': 'Special review from guest',

  // Product lists page
  'productlists-popular-filter': 'Popular filters',
  'productlists-price-per-night': 'Price',
  'productlists-price': 'Price/Night',
  'productlists-price-low-high': 'Price low to high',
  'productlists-price-high-low': 'Price high to low',
  'productlists-hotel-star': 'Hotel star',
  'productlists-hotel-star-1-5': 'Star 1-5',
  'productlists-hotel-star-5-1': 'Star 5-1',
  'productlists-no-star-rating': 'No star rating',
  'productlists-your-balance': 'Your budget limit is THB X,XXX/room/night',
  'productlists-sorting': 'Sort by',
  'productlists-filter': 'Filter',
  'productlists-filter-by': 'Filter by',
  'productlists-more': 'More',
  'productlists-recommendation': 'Recommended',
  'productlists-score': 'Guest rating',
  'productlists-poi-distance': 'Distance',
  'productlists-hotel-name': 'Hotel name',
  'productlists-hotel-name-sorting-a-z': 'A-Z',
  'productlists-hotel-name-sorting-z-a': 'Z-A',
  'productlists-special-price': 'Special price applied on company only',
  'productlists-available-room': 'Only {X} rooms left!',
  'product-booknow': 'Book now, Pay on {9 Jul 17}',
  'productlists-see-room': 'See all rooms',
  'productlists-night': 'night',
  'productlists-no-room-left': 'No available rooms on selected dates',
  'productlists-recommended-title': 'Special price of employee who book via Ascend Travel Only',
  'productlists-found-01': 'Found',
  'productlists-found-02': 'properties.',
  'productlists-found-03': 'Showing',
  'productlists-pop-up-error': 'System error. Please try again.',
  'productlists-pop-up-error-missing-email-header': 'Missing user’s email from CPF Web Service.',
  'productlists-pop-up-error-missing-email': 'Please contact CPF HRIS through the Ask HR channel.<br/>1. Go to <a class="link-hover-style" href="https://cpffamily.cpf.co.th" target="_blank">https://cpffamily.cpf.co.th</a><br/>2. Go to <span class="bold">HR-eXp</span> and click  <span class="bold">Ask HR</span> button on the top right.',
  'productlists-pop-up-error-across-month': 'Your company not allow to book across months.',
  'productlists-pop-up-error-across-month-share-budget': 'Your company or co-booker company not allow to book across months.',
  'productlists-not-found': 'Sorry, we couldn\'t find any properties from your search keyword. Try one of these popular destination instead.',
  'productlists-business-desination': 'Distance from destination',
  'productlists-business-desination-kilometer': 'km.',
  'productlists-business-distance': 'From {poi} {km} km.',
  'productlists-hotel-review': 'Review scores',
  'productlists-hotel-review-9': 'Exceptional: 9+',
  'productlists-hotel-review-8': 'Excellent: 8+',
  'productlists-hotel-review-7': 'Very good: 7+',
  'productlists-hotel-review-6': 'Review Score: 6+',
  'productlists-hotel-review-nonreview-newhotel': 'New or waiting review',
  'productlists-filter-header': 'Filters',
  'productlists-filter-clear': 'Clear all',
  'productlists-filter-submit': 'Apply',
  'productlists-filter-show-more-item': 'Show more',
  'productlists-filter-facility': 'Facilities',
  'productlists-filter-include-breakfast': 'Breakfast included',
  'productlists-filter-popup-include-breakfast': 'Breakfast included',
  'productlists-filter-location': 'Location',
  'productlists-filter-location-search': 'Location',
  'productlists-filter-over-budget': 'Book without budget<br>limit',
  'productlists-filter-popup-over-budget': 'Book without budget limit',
  'productlists-filter-clear-btn': 'Clear',
  'productlists-over-budget': 'Over Budget',
  'productlists-bestSeller': 'Best Seller',
  'productlists-topBooking': 'Top Booking',
  'productlists-bestReview': 'The Best Review Accommodations',
  'productlists-specialRecommendation': 'Special Recommendation',
  'productlists-holidayOffer': 'Holiday Offer',
  'productlists-midMonth': 'MID MONTH - Limited time offer!',
  'productlists-summerDeal': 'Summer Deal',
  'productlists-flashDeal': 'Flash Deal',
  'productlists-bestDeal': 'Best Deal',
  'productlists-room-breakfast': 'Breakfast Included',
  'productlists-positive-energy': 'Positive Energy',
  'productlists-positive-energy-work': 'Work',
  'productlists-positive-energy-wealth': 'Wealth',
  'productlists-positive-energy-love': 'Love',
  'productlists-positive-energy-family': 'Family',
  'productlists-positive-energy-friendship': 'Friendship',
  'productlists-positive-energy-fortune': 'Fortune',
  'productlists-positive-energy-health': 'Health',
  'productlists-positive-energy-patronage': 'Patronage',
  'productlists-positive-energy-reputation': 'Reputation',

  // Product list - guest review rating title
  'product-review-rating-exceptional': 'Exceptional',
  'product-review-rating-excellent': 'Excellent',
  'product-review-rating-very-good': 'Very good',
  'product-review-rating-review-score': 'Review Score',

  // Product detail page
  'product-detail-choose-your-room': `Select room type`,
  'product-detail-room-type': `Room type`,
  'product-detail-room-condition': `Details & Conditions`,
  'product-detail-number-of-guest': `Capacity`,
  'product-detail-price-today': `Price per night`,
  'product-detail-amount-room': `Room`,
  'product-detail-room-last-five': `Only {room} rooms left!`,
  'product-detail-room-breakfast': `Breakfast Included`,
  'product-detail-room-all-inclusive': `Breakfast, Lunch, Dinner and Beverages Included`,
  'product-detail-room-full-board': `Breakfast, Lunch and Dinner Included`,
  'product-detail-room-half-board': `Breakfast and Lunch or Breakfast and Dinner Included`,
  'product-detail-room-only': `Room Only`,
  'product-detail-room-condition-cancellation-fee': 'Cancellation with fee',
  'product-detail-room-cancellation-policy': `Cancellation Policy`,
  'product-detail-room-cancellation-non-refundable': `Special Rate (Non-Refundable)`,
  'product-detail-room-cancellation-charge': `- If cancel after {date}, will incur cancellation charge for {currency} {amount} per room`,
  'product-detail-room-cancellation-night': `- If cancel after {date}, will incur cancellation charge first {night} room night`,
  'product-detail-room-cancellation-percent': `- If cancel after {date}, will incur cancellation charge {percent}% of total price`,
  'product-detail-room-cancellation-free': `Free Cancellation if cancel before {date}`,
  'product-detail-room-paylater-description': `Book now, Pay on {date}`,
  'product-detail-budget-limit': `Your budget limit is <strong>{x}</strong> /room/night`,
  'product-detail-new-budget-limit': `Your new budget limit is <strong>{x}</strong> /room/night`,
  'product-detail-room-over-limit': `Over Budget`,
  'product-detail-room-over-price': `Pay more`,
  'product-detail-room-night': `/night`,
  'product-detail-tooltip-price-per-night': `1 room x 1 night`,
  'product-detail-tooltip-user-budget': `Budget per room per night`,
  'product-detail-tooltip-pay-over-budget': `Pay more`,
  'product-detail-image-map-description': `*Click on map to see nearby hotels.`,
  'product-detail-review-mysterious-things': 'Mysterious things',
  'product-detail-review-pest': 'Pest',
  'product-detail-bathroom': 'bathroom',
  'product-detail-private-bathroom': 'Private bathroom',
  'product-detail-shared-bathroom': 'Shared bathroom',
  'product-detail-bedroom': 'bedroom',
  'product-detail-sqm': 'sq. m.',
  'product-detail-information': 'More information',
  'extra-bed-include-in-room-price': 'Extra bed(s) included in room price',
  'extra-bed-include': `{text} Extra Bed Included`,
  'product-detail-room-note-title': 'Benefits & Information',
  'product-detail-room-note-see-more': 'View more',

  'room-detail-title': `Room Type Details`,
  'room-not-available-line-1': `Sorry, there is no available room for the dates you searched.`,
  'room-not-available-line-2': `Please change your dates.`,

  'room-price-change-line-1': 'Room rate has changed.',
  'room-price-change-line-2': 'You can see the new price',
  'room-price-change-line-3': 'as information below.',
  'room-price-change-space': ' ',
  'room-price-change-col-1': 'Room Type',
  'room-price-change-col-2': 'Previous Price',
  'room-price-change-col-3': 'New Price',
  'room-price-btn-accept': 'Accept',
  'room-price-btn-back': 'Back to Search',

  'show-photo': `Photo`,
  'product-description-text-sha-title': 'SHA : Amazing Thailand Safety & Health Administration',
  'product-description-text-sha-plus-title': 'SHA Plus : Amazing Thailand Safety & Health Administration',
  'product-description-text-sha-desc': 'The property have successfully passed a strict inspection of preventive measures by Tourism Authority of Thailand (TAT) implemented to ensure that both Thai and foreign tourists have a positive experience.',
  'product-description-text-sha-plus-desc': 'The property have successfully passed a strict inspection of preventive measures by Tourism Authority of Thailand (TAT) implemented to ensure that both Thai and foreign tourists have a positive experience. And at least 70% of staff at the venues and businesses have been fully vaccinated against COVID-19.',
  'product-description-text-sha-certificate-id': 'Certificate ID',
  'product-description-text-property-opened': 'Property opened',
  'product-description-text-recent-renovation': 'Recent renovation',

  'sanitized-stay-title': 'Sanitized Stay',
  'product-detail-dialog-continue-with-my-budget': 'Do you still want to book and pay by your budget?',
  'product-detail-dialog-continue-with-credit-card': 'Do you still want to book and pay by your budget?',
  'product-detail-dialog-continue-with-multi-payment': 'Do you still want to book and pay by your budget?',
  'product-detail-dialog-continue-confirm-with-my-budget': 'Continue',
  'product-detail-dialog-continue-confirm-with-credit-card': 'Continue',
  'product-detail-dialog-continue-confirm-with-multi-payment': 'Continue',
  'product-detail-dialog-continue-sub-text-with-my-budget': 'You cannot share budget with co-booker. If you confirm to continue booking, we will remove share budget and you must pay by your budget.',
  'product-detail-dialog-continue-sub-text-with-credit-card': 'You cannot share budget with co-booker. If you confirm to continue booking, we will remove share budget and you must pay by your budget.',
  'product-detail-dialog-continue-sub-text-with-multi-payment': 'You cannot share budget with co-booker. If you confirm to continue booking, we will remove share budget and you have to pay for the exceeding amount by your own. ',
  'product-detail-dialog-btn-continue': 'Continue',

  // booking
  'booking-cancellation-fee': 'Cancellation Fee',
  'booking-cancellation-fee-2': 'Cancellation Fee',
  'booking-cancellation-fee-3': 'Reject a reservation',
  'booking-cancellation-free': 'No Cancellation Fee.',
  'booking-cancellation-free-2': 'You can reject this booking with no cancellation fee.',
  'booking-cancellation-booking-id': 'Booking ID',
  'booking-cancellation-if-cancel-text': 'If you cancel this booking, it will have cancellation fee by below details.',
  'booking-cancellation-if-cancel-text-2': 'If you reject this booking, it will have cancellation fee by below details.',
  'booking-cancellation-room-type': 'Room Type',
  'booking-cancellation-total': 'Total Cancellation Fee',
  'booking-cancellation-note': 'Note',
  'booking-cancellation-note-text': 'Cancellation fee can be changed depend on the cancellation period you submit.',
  'booking-cancellation-promotion-text': 'If a promo code is applied, the cancellation fee will be calculated based on the net price after discount, or as determined by the company.',
  'booking-cancellation-btn-confirm': 'Confirm',
  'booking-cancellation-btn-confirm-2': 'Reject',
  'booking-cancellation-btn-close': 'Back',
  'booking-cancellation-empty': 'No Booking',
  'booking-cancel-success': 'Cancel Booking ID {bookingID} Successful.',
  'booking-cancel-failure': 'Cancel Booking ID {bookingID} Failed. Please try again.',
  'booking-cancel-date': 'Cancel Date',
  'booking-cancellation-credit-terms': 'Cancellation fee charge to credit terms',
  'booking-cancellation-credit-terms-main-booker': 'Main booker',
  'booking-cancellation-credit-terms-co-booker': 'Co-booker',
  'booking-cancellation-credit-card': "Cancellation fee charge to card holder's credit/debit card",
  'booking-cancellation-true-money': "Cancellation fee charge to TrueMoney Wallet",
  'booking-cancellation-corporate-fleet': `Cancellation fee charge to card holder's corporate fleet card`,
  'booking-cancellation-personal-fleet': `Cancellation fee charge to card holder's personal fleet card`,
  'booking-cancellation-multipayment': 'Separate into 2 payment methods',
  'booking-cancellation-reject-reason-label': 'Reject reasons',
  'booking-cancellation-reject-reason-placeholder': 'Please specify reasons...',
  'booking-cancellation-reject-reason-error-required': 'Please enter reasons to reject.',
  'booking-cancellation-refund-details': 'We are unable to automatically process refunds once a cancellation has been ordered. Customer must make a request for a <span class="refund-themselves"">refund by themselves</span> through the refund request. Please contact <b>Call Center : +66(0) 2-020-2351</b> or <b>Line Official Account : @AscendTravel</b>',
  'product-menu-photo': `Photo`,
  'product-menu-room': `Select Rooms`,
  'product-menu-detail': `Hotel Detail`,
  'product-menu-facility': `Facilities`,
  'booking-arranged-by': 'Arranged By',
  'booking-report': 'Booking report (.xlsx)',
  'booking-report-dialog-title': 'Booking Report by Check-in Period',
  'booking-report-check-in-from': 'From',
  'booking-report-check-in-to': 'To',
  'booking-report-placeholder-from': 'Tu. 1 Jan 19',
  'booking-report-placeholder-to': 'Th. 31 Jan 19',
  'booking-report-information': 'There are only bookings paid by credit terms in this report.',
  'booking-report-data-not-found': 'There is no booking paid by credit terms in the selected period.',
  'booking-report-export-error': 'Export report failed. Please try again.',
  'dialog-booking-report-error': 'Please select check-in period.',
  'booking-condition-popup-title': 'Cancellation policy',
  'booking-condition-popup-detail-1': 'If cancel after',
  'booking-condition-popup-detail-2': ', will incur cancellation charge for THB',
  'booking-condition-popup-detail-3': 'per room',

  // cart
  'cart-booking-detail': `Booking details`,
  'cart-price-for': `Price for`,
  'cart-night': `night`,
  'cart-time-from': `From`,
  'cart-time-until': `Until`,
  'cart-room': `room`,
  'cart-room-type-detail': `Room details`,
  'cart-grand-total': `Grand Total`,
  'cart-include-vat-label': `Price already include VAT and service charge.`,
  'cart-credit-card-label': `For Credit/Debit Card payment method,`,
  'cart-non-refund-label': `Non Refundable Price`,
  'cart-pay-on-label': `Pay date will be on`,
  'cart-book-now': `Book now`,
  'cart-select-room': `Please select number of room.`,
  'cart-button-continue': `Continue`,
  'cart-button-confirm-to-book': `Confirm to Book`,
  'cart-surcharge-include': `Price already include VAT, {text} and Service Charge.`,
  'cart-surcharge-exclude': `Not included in price (collected by the property): {text}`,
  'cart-seperate-payment': `Separate into 2 payment methods`,
  'cart-seperate-payment-credit-terms': `Separate payment into`,
  'cart-pay-credit-terms': `Pay by credit terms`,
  'cart-pay-corporate-fleet': `Pay by corporate fleet card`,
  'cart-pay-personal-fleet': `Pay by personal fleet card`,
  'cart-pay-corporate-fleet-new-line': `Pay by corporate fleet card`,
  'cart-pay-personal-fleet-new-line': `Pay by personal fleet card`,
  'cart-pay-debit-card': `Pay more`,
  'cart-multi-pay-label': `For multi-payment, payment date will be`,
  'cart-max-guest': '',
  'cart-adult-text': 'Max',
  'cart-child-text': '',
  'cart-adult': 'adult',
  'cart-child': 'child',
  'cart-children': 'children',
  'cart-budget-no-remaning': 'You have to pay by your own due to ',
  'cart-budget-detail-below': ', you have to pay for the exceeding amount by your own.',
  'cart-budget-no-remaning-mobile': 'You have to pay by your own.',
  'cart-budget-detail-mobile': 'You have to pay for the exceeding amount by your own.',
  'cart-booker': 'Booker',
  'cart-co-booker': 'Co-Booker',
  'cart-cannot-share-budget': 'You cannot share budget with co-booker, please',
  'cart-before-continuing': 'continuing your booking.',
  'cart-btn-cannot-share-budget': 'cancel share budget',
  'cart-share-budget-detail-below': ' You have to pay for the exceeding amount by your own.',
  'cart-budget-over-budget-mobile': 'You have to pay more for the amount over budget',
  'cart-budget-over-budget-book-for-traveller': 'The price exceeds guest’s budget limit. ',
  'cart-budget-over-budget-book-for-traveller-sub-text': 'Please select new room.',
  'cart-currency-note': 'We will charge your booking in THB. The price shown in {currency} is an approximate conversion of THB to {currency}, based on the current exchange rate. (Please note that exchange rates are subject to change.)',
  'cart-approximate-price-in': 'Approximate price in',
  'cart-taxes-fees': 'Taxes & Fees',
  'cart-taxes-fees-description': 'This charge includes estimated amounts the travel service provider (i.e. hotel, car rental company) pays for their taxes, and/or taxes that we pay, to taxing authorities on your booking (including but not limited to sales, occupancy, and value added tax). This amount may also include any amounts charged to us for resort fees, cleaning fees, and other fees and/or a fee we, the hotel supplier and/or the site you booked on, retain as part of the compensation for our and/or their services, which varies based on factors such as location, the amount, and how you booked. For more details, please see the terms and conditions.',
  'cart-terms-conditions': 'By completing this booking you agree to the',
  'cart-terms-conditions-and': 'and',
  'cart-terms-conditions-supplier': 'Supplier Terms and Conditions',
  'cart-terms-conditions-agent': 'Agent Terms of Use',
  'cart-price-info': 'Price Information',
  'cart-discount': 'Discount',
  'cart-promotion-code': 'Promotion Code',
  'cart-select-code': 'Select Code',
  'cart-promotion-code-discount': 'Promotion Code Discount',
  'cart-promotion-code-error-invalid_payment_method': 'Please use a different payment method to apply this code.',
  'cart-promotion-code-error-reached_limit': 'Please use a different code. This code has reached its limit.',
  'cart-promotion-code-error-condition_not_met': 'Please use a different code. This code does not meet the conditions.',
  'cart-dialog-use-promotion-code-title': 'Promotion Code',
  'cart-dialog-use-promotion-code-search-placeholder': 'Enter your promotion code',
  'cart-dialog-use-promotion-code-best-deal': 'Best Deal',
  'cart-dialog-use-promotion-code-btn-search': 'Apply Code',
  'cart-dialog-use-promotion-code-search-error-invalid': 'Invalid promotion code. Please check and try again.',
  'cart-dialog-use-promotion-code-discount': '{amount} Off',
  'cart-dialog-use-promotion-code-max-discount-per-book': 'Up to {amount}',
  'cart-dialog-use-promotion-code-min-spend-per-book': 'Minimum booking of {amount}',
  'cart-dialog-use-promotion-code-min-spend-per-book-no-limit': 'No minimum required',
  'cart-dialog-use-promotion-code-term-condition': 'T&C',
  'cart-dialog-use-promotion-no-promotion-code': 'No valid code available.',
  'cart-dialog-use-promotion-credit-terms': 'Valid only for Credit Terms payments.',
  'cart-dialog-use-promotion-credit-debit-card-bank': 'Valid only for {bank} Card payments.',
  'cart-dialog-use-promotion-credit-card': 'Valid only for {bank}Credit Card payments.',
  'cart-dialog-use-promotion-debit-card': 'Valid only for {bank}Debit Card payments.',
  'cart-dialog-use-promotion-payment': 'Valid only for {payment} payments.',
  'cart-dialog-use-promotion-promotional-code-participating-payment-methods': 'This code is valid only for participating payment methods.',
  'cart-dialog-use-promotion-discount': 'Promotional code discount',
  'cart-dialog-confirm-continue-without-promotion-code-title': 'Proceed without using the code?',
  'cart-dialog-confirm-continue-without-promotion-code-desc': 'This promotion code is not valid for this booking.<br>You can continue without applying the code or go back to select a different one.',
  'cart-dialog-confirm-continue-without-promotion-code-cancel': 'Choose another code',
  'cart-dialog-confirm-continue-without-promotion-code-cancel-short': 'Try another',
  'cart-dialog-confirm-continue-without-promotion-code-confirm': 'Proceed without the code',
  'cart-dialog-error-session-expired-title': 'This search has expired',
  'cart-dialog-error-session-expired-description': 'Because the booking time limit has been reached.<br>Please search again.',

  // Month
  'day-select': 'Day',
  'year-select': 'Year',
  'month-select': 'Month',
  'month-january': 'January',
  'month-february': 'February',
  'month-march': 'March',
  'month-april': 'April',
  'month-may': 'May',
  'month-june': 'June',
  'month-july': 'July',
  'month-august': 'August',
  'month-september': 'September',
  'month-october': 'October',
  'month-november': 'November',
  'month-december': 'December',

  // Thank you
  'thankyou-download-voucher': 'Download voucher',
  'thankyou-print-voucher': 'Print',
  'thankyou-office-address-name': 'Ascend Travel Co.,Ltd. (Head Office)',
  'thankyou-office-address-location': 'AIA Capital Center Building, 18-19 Floor, 89 Ratchadaphisek Road, Dindaeng, Dindaeng, Bangkok 10400',
  'thankyou-office-address-taxnum': 'Tax ID : 0105559069212',
  'thankyou-bookingId-ref': 'Ref. with Ascend Travel',
  'thankyou-bookingId-hotel-ref-number': 'Hotel Booking ID',
  'thankyou-bookingId-hotel-book-by': 'Booked and payable by ',
  'thankyou-payment-title': 'Payment Method',
  'thankyou-payment-detail': 'Credit/Debit Card',
  'thankyou-payment-detail-true-money': 'TrueMoney Wallet',
  'thankyou-payment-detail-2': 'Credit Terms',
  'thankyou-payment-creditcard-details': 'Easy to pay via Credit Card/Debit Card without fee with convenience, express checkout and save & secure 24 hours.',
  'thankyou-payment-date': 'Payment date',
  'thankyou-booking-details': 'Booking Details',
  'thankyou-details-props-info': 'Property Information',
  'thankyou-details-props-name': 'Property Name',
  'thankyou-details-props-address': 'Address',
  'thankyou-details-props-phone': 'Phone',
  'thankyou-details-details': 'Booking Details',
  'thankyou-details-roomtype': 'Room type',
  'thankyou-details-price': 'Price',
  'thankyou-guest-order-number': 'Guest',
  'thankyou-guest-special-request': 'Special Request',
  'thankyou-room-condition': `Room's condition`,
  'thankyou-details-vat': 'Price (Excluding VAT)',
  'thankyou-price-vat': 'VAT',
  'thankyou-price-total': 'Grand Total',
  'thankyou-thankyou-statement-01': "Thank you for your trust in using Ascend Travel's services.",
  'thankyou-thankyou-statement-02': "You can contact us via Call Center +66(0) 2-020-2351 with 24 hours service everyday.",
  'thankyou-status-pay-now-success-title': 'Your payment is processed successfully.',
  'thankyou-status-pay-now-success-text': 'Thank you for your trust in using Ascend Travel services.',
  'thankyou-status-pay-later-success-title': 'Your reservation is processed successfully',
  'thankyou-status-pay-later-success-text': 'Thank you for your trust in using Ascend Travel services.',
  'thankyou-status-pay-now-fail-title': 'Your credit/debit card payment is failed',
  'thankyou-status-tmn-pay-now-fail-title': 'Your TrueMoney Wallet payment is failed',
  'thankyou-status-fleet-pay-now-fail-title': 'Your fleet card payment is failed',
  'thankyou-status-payment-fail-title': 'Your payment is failed.',
  'thankyou-status-fleet-pay-now-fail-sub-title': 'Please check your card balance or contact call center +66(0) 2-020-2351.',
  'thankyou-status-pay-now-fail-text': 'Please check your card information or contact issuing bank.',
  'thankyou-status-tmn-pay-now-fail-default-text': 'Please check your TrueMoney Wallet account or contact TrueMoney Customer Care.',
  'thankyou-status-payment-fail-text': 'Please check your account or complete the transaction again.',
  'thankyou-status-tmn-pay-now-fail-invalid-card-number-text': 'Your TrueMoney Wallet phone number does not exist. Please contact TrueMoney Customer Care.',
  'thankyou-status-tmn-pay-now-fail-insufficient-funds-text': 'Insufficient balance in your TrueMoney Wallet account. Please topup your account balance and make payment again.',
  'thankyou-status-payment-fail-description': 'Payment failed',
  'thankyou-status-payment-credit-terms-fail-description': 'No payment has been charged to your company.',
  'thankyou-status-payment-credit-terms-share-budget-fail-description': 'No payment has been charged to your company and co-booker’s company.',
  'thankyou-status-payment-credit-card-fail-description': 'No payment has been charged to your issuing bank.',
  'thankyou-status-payment-tmn-fail-description': 'No payment has been charged to your TrueMoney Wallet account.',
  'thankyou-status-payment-fleet-fail-description': 'No payment has been charged to your fleet card.',
  'thankyou-status-payment-account-fail-description': 'No payment will be deducted from your account.',
  'thankyou-status-seperate-payment-method': 'Separate into 2 payment methods',
  'thankyou-more-information': 'Additional information',
  'thankyou-status-booking-success-title': 'Your reservation is processed successfully.',
  'thankyou-status-booking-success-text': 'You will receive email confirmation again.<br />Thank you for your trust in using Ascend Travel service.',
  'thankyou-status-booking-fail-title': 'Your booking is failed',
  'thankyou-status-booking-fail-text': "We're really sorry. Because the room type you have selected has many customers interested too and the last room just booked by another customer.",
  'thankyou-status-cannot-create-temp-booking-title': "Your booking is failed.",
  'thankyou-status-cannot-create-temp-booking-text': "Please try again.",
  'thankyou-status-timeout-title': 'Please check your booking status at menu "Booking".',
  'thankyou-status-timeout-text': "There was an error while processing your booking.",
  'thankyou-surcharge-exclude': `The prices do not include {text} which will be collected by the property. Please request Receipt/Tax invoice from the property after payment has been made.`,
  'thankyou-payment-successful': 'Payment successful',
  'thankyou-booking-successful': 'Booking successful',
  'thankyou-booking-pay-on': 'Pay on',
  'thankyou-booking-credit-terms-title': 'Credit Terms',
  'thankyou-booking-credit-terms-success': 'We will process to issue invoice to your company as per credit terms agreed.',
  'thankyou-booking-credit-terms-share-budget-success': 'We will process to issue invoice to your company and co-booker’s company as per credit terms agreed.',
  'thankyou-payment-detail-total-title': 'Payment details',
  'thankyou-booking-id': 'Booking ID',
  'thankyou-we-send-information': 'We have sent the confirmation e-mail to',
  'thankyou-total-price': 'Total price',
  'thankyou-voucher': 'Voucher',
  'thankyou-tax-invoice': 'Tax invoice/Receipt',
  'thankyou-back-home-button': 'Back to home',
  'thankyou-booking-detail-button': 'View booking details',
  'thankyou-check-booking-button': 'View booking',
  'thankyou-on-process': 'Your booking is on process',
  'thankyou-booking-corporate-fleet-title': 'Corporate fleet card',
  'thankyou-booking-personal-fleet-title': 'Personal fleet card',

  // Booking Details
  'booking-details-btn-back': 'Back to booking',
  'booking-details-dropdown-title': 'Download document',
  'booking-details-save-voucher': 'Save Voucher',
  'booking-details-save-tax-invoice': 'Save Tax Invoice',
  'booking-details-save-tax-invoice-cancel': 'Save Tax Invoice Cancel',
  'booking-details-save-credit-note': 'Save Credit Note',

  //Payment method detail component
  'payment-method-detail-payment-title': 'Payment method',
  'payment-method-detail-payment-date': 'Payment date',
  'payment-method-detail-payment-multi-payment-expand': 'Credit Terms and Credit/Debit Card',
  'payment-method-detail-payment-credit-terms': 'Credit Terms',
  'payment-method-detail-payment-credit-card': 'Credit/Debit Card',
  'payment-method-detail-payment-true-money': 'TrueMoney Wallet',
  'payment-method-detail-payment-corporate-fleet': 'Corporate fleet card',
  'payment-method-detail-payment-personal-fleet': 'Personal fleet card',
  'payment-method-detail-payment-date-credit-card': 'Payment Date',
  'payment-method-detail-payment-date-credit-terms': 'As we have agreed on credit terms',
  'payment-method-detail-payment-date-credit-terms-no-charge': 'No payment has been charged to your company.',
  'payment-method-detail-payment-date-true-money-no-charge': 'No payment has been charged to your TrueMoney Wallet account.',
  'payment-method-detail-payment-date-credit-card-no-charge': 'No payment has been charged to your issuing bank.',
  'payment-method-detail-payment-date-fleet-no-charge': 'No payment has been charged to your fleet card.',
  'payment-method-detail-payment-date-payment-no-charge': 'No payment has been charged to your account.',
  'payment-method-detail-payment-date-refund-policy': 'Refund policy',
  'payment-method-detail-payment-date-refund-policy-details-credit-card': 'We processes refunds immediately after booking cancelled. Credit card holders will receive the refunded amount in their next billing cycle. For debit cards, the amount will be returned within 30-60 days.',
  'payment-method-detail-payment-date-refund-policy-details-true-money': ' We processes refunds immediately after booking cancelled. True Money account holder will receive a refund to the True Money Wallet within 14-30 working days.',
  'payment-method-detail-payment-date-refund-policy-details-fleet': 'We processes refunds immediately after booking cancelled.  Fleet card holders will receive the refunded amount within 30 minutes.',
  'payment-method-detail-payment-date-refund-policy-details-payment': 'We are unable to automatically process refunds once a cancellation has been ordered. Customer must make a request for a refund by themselves through the refund request. Please contact <b>Call Center : +66(0) 2-020-2351</b> or <b>Line Official Account : @AscendTravel</b>',
  'payment-method-detail-payment-date-refund-policy-details-e-wallet': 'We processes refunds immediately after booking cancelled. Rabbit LINE Pay account holder will receive a refund to Rabbit LINE Pay within 14-30 working days.',

  // Booking detail component
  'booking-detail-bookingId-ref-number': 'Booking ID',
  'booking-detail-bookingId-hotel-ref': 'Ref. with hotel',
  'booking-detail-booking-date-and-time': 'Booking date/time',
  'booking-detail-details-booking-detail-title': 'Booking details',
  'booking-detail-details-checkin': 'Check-in',
  'booking-detail-details-checkout': 'Check-out',
  'booking-detail-details-from': 'from',
  'booking-detail-details-before': 'until',
  'booking-detail-details-period': 'Period of stay',
  'booking-detail-details-night': 'night',
  'booking-detail-details-room-amount': 'No. of room',
  'booking-detail-details-room': 'room',
  'booking-detail-details-total-max-guest': 'No. of guest',
  'booking-detail-details-max-guest': 'No. of guest',
  'booking-detail-details-adult-text': 'Max',
  'booking-detail-details-child-text': 'Max',
  'booking-detail-details-adult': 'adult',
  'booking-detail-details-child': 'child',
  'booking-detail-details-children': 'children',
  'booking-detail-details-children-age': '(ages {age})',
  'booking-detail-details-room-guest-amount': 'No. of room and guest',
  'booking-detail-details-and': 'and',

  'booking-detail-details-traveller-info-title': 'Guest details',
  'booking-detail-details-traveller-info-table-room-header': 'Room',
  'booking-detail-details-traveller-info-table-guest-header': 'Guest',
  'booking-detail-details-traveller-info-table-guest-number-header': 'Guest',
  'booking-detail-details-traveller-info-table-supervisor-header': 'Supervisor',
  'booking-detail-details-traveller-info-table-pending-status': 'Awaiting approval',
  'booking-detail-details-traveller-info-table-approved-status': 'Approved',
  'booking-detail-details-traveller-info-table-rejected-status': 'Rejected',
  'booking-detail-details-traveller-info-table-unable-status': 'Cannot approve or reject reservation',

  'booking-detail-details-room-detail-title': 'Room details',
  'booking-detail-details-room-title': '1 room x',
  'booking-detail-details-room-guest': 'Guest',
  'booking-detail-details-room-special-request': 'Special request',
  'booking-detail-cancellation-policy-free-of-charge': 'Free Cancellation if cancel before',
  'booking-detail-details-room-non-refund': 'Special Rate (Non-Refundable)',
  'booking-detail-room-cancellation-policy': `Cancellation policy`,
  'booking-detail-cancellation-policy-charge': '- If cancel after {date}, will incur cancellation charge for {currencycode} {cancelFee} per room',
  'booking-detail-room-price-total': 'Total',
  'booking-detail-details-room-benefits': `Benefits & Information`,

  'booking-detail-details-booker-information-title': 'Booker information',
  'booking-detail-details-main-booker-information-title': 'Main booker information',
  'booking-detail-details-booker-name': 'Booker name',
  'booking-detail-details-main-booker-name': 'Main booker name',
  'booking-detail-details-booker-id': 'Member ID',
  'booking-detail-details-booker-phonenum': 'Contact number',
  'booking-detail-details-booker-email': 'Email',
  'booking-detail-details-supervisor-fullname': 'Supervisor name',
  'booking-detail-details-supervisor-email': 'Email',
  'booking-detail-details-booker-company-name': 'Company name/Name',
  'booking-detail-details-booker-company-tax': 'Tax ID/Personal ID',
  'booking-detail-details-booker-company-address': 'Tax invoice/Receipt address',
  'booking-detail-details-credit-terms-title': 'Tax invoice information - Credit Terms',
  'booking-detail-details-credit-card-title': 'Tax invoice information - Credit/Debit Card',
  'booking-detail-details-true-money-title': 'Tax invoice information - TrueMoney Wallet',
  'booking-detail-details-co-booker-information-title': 'Co-booker information',
  'booking-detail-details-co-booker-name': 'Co-booker name',
  'booking-detail-arrival-time': 'Arrival time',

  'cart-notify-over-room-limit': 'You can book maximum 9 rooms/booking',
  'cart-notify-add-cart-fail': 'This property cannot be booked temporarily. <br />Please select another property instead. <br />Sorry for the inconvenience.',
  'cart-notify-add-cart-fail-fit-invalid-number-of-adult': 'Sorry, we cannot process your booking. (FIT9)<br />Please contact call center <br />for more information.<br />Call center: +66(0) 2-020-2351',

  // checkout
  'checkout-step1': 'Booking details',
  'checkout-step2': 'Customer information',
  'checkout-step3': 'Payment information',

  'checkout-1-booking-details': 'Booking details',
  'checkout-1-view-map': 'View map',
  'checkout-1-checkin': 'Check-in',
  'checkout-1-checkout': 'Check-out',
  'checkout-1-from': 'from',
  'checkout-1-until': 'until',
  'checkout-1-period': 'Period of stay',
  'checkout-1-night-unit': 'night',
  'checkout-1-room-amount': 'No. of room and guest',
  'checkout-1-room-unit': 'room',
  'checkout-1-guest-amount': 'No. of guest',
  'checkout-1-adult-title': '{X} adult',
  'checkout-1-child-title': '{X} child',
  'checkout-1-children-title': '{X} children',
  'checkout-1-ages': 'ages',
  'checkout-1-and': 'and',
  'checkout-1-year': '',
  'checkout-1-max-adult-title': 'Max {X} adult',
  'checkout-1-max-child-title': '{X} child',
  'checkout-1-max-children-title': '{X} children',
  'checkout-1-room-detail-max-guest': 'No. of guest',
  'checkout-1-adult': 'Adult',
  'checkout-1-child': 'Child',
  'checkout-1-room-detail': 'Room details',
  'checkout-1-room-type': 'Room Type',
  'checkout-1-price-per-night': 'Price/night',
  'checkout-1-night': 'Night',
  'checkout-1-room': 'Room',
  'checkout-1-total': 'Total',
  'checkout-1-note': 'Note',
  'checkout-1-max-adult': 'Max {X} adults',
  'checkout-1-max-child': 'Max {X} children',
  'checkout-1-extrbed': '{X} Extra Bed Incleded',
  'checkout-1-description': 'Description',
  'checkout-1-bed-type-available': '(Cannot be guaranteed)',

  // checkout 2
  'checkout-2-booker-information-title': 'Booker information',
  'checkout-2-guest-information-title': 'Guest information',
  'checkout-2-topic-title': 'Travelling for',
  'checkout-2-booker-name-title': 'Booker name',
  'checkout-2-booker-name-title-more': '(Please enter in English only)',
  'checkout-2-form-firstname-title': 'Name',
  'checkout-2-form-lastname-title': 'Surname',
  'checkout-2-form-full-name-title': 'Booker name',
  'checkout-2-form-email-title': 'Email',
  'checkout-2-form-number-title': 'Phone number',
  'checkout-2-form-nationality-title': 'Nationality',
  'checkout-2-button-add-guest': 'Add guest',
  'checkout-2-button-display-more-details': 'Add special request',
  'checkout-2-button-display-hide-details': 'Hide special request',
  'checkout-2-room-number-title': 'Room',
  'checkout-2-guest-number-title': 'Guest name',
  'checkout-2-guest-number-title-without-index': 'Guest name',
  'checkout-2-button-delete-guest': 'Delete guest',
  'checkout-2-special-request-title': 'Special request',
  'checkout-2-special-request-title-eng-only': 'Special request (Please enter in English only)',
  'checkout-2-special-request-english-only': 'Special request must input in english only',
  'checkout-2-special-request-legend': 'We\'ll send your request right after you book. Special request cannot be guaranteed and may incur charges, but the property will do its best to meet your wish.',
  'checkout-2-form-require-full-name': 'Please enter your first name and last name.',
  'checkout-2-form-invalid-full-name': 'Please enter your name in English only.',
  'checkout-2-form-require-firstname': 'Please enter your first name.',
  'checkout-2-form-require-lastname': 'Please enter your last name.',
  'checkout-2-form-invalid-firstname': 'Please enter your first name in English only.',
  'checkout-2-form-invalid-lastname': 'Please enter your last name in English only.',
  'checkout-2-form-require-mobile-number': 'Please enter your phone number.',
  'checkout-2-form-invalid-mobile-number': 'Please enter a valid phone number.',
  'checkout-2-form-require-booker-email': `Please enter your email.`,
  'checkout-2-form-invalid-booker-email': `Your email is incorrect. Please check and try it again.`,
  'checkout-2-form-require-guest-firstname': 'Please enter guest name.',
  'checkout-2-form-require-guest-lastname': 'Please enter guest surname.',
  'checkout-2-form-require-guest-full-name': 'Please enter guest\'s first name and last name.',
  'checkout-2-form-require-guest-email': `Please enter guest's email.`,
  'checkout-2-form-require-guest-nationality': `Please enter guest's nationality.`,
  'checkout-2-form-invalid-guest-firstname': 'Guest name must input in english only.',
  'checkout-2-form-invalid-guest-lastname': 'Guest surname must input in english only.',
  'checkout-2-form-invalid-guest-email': 'Guest email is incorrect. Please check and try it again.',
  'checkout-2-autocomplete-remove-guest': 'Remove',
  'checkout-2-save-new-guest': 'Save this guest to the list',
  'checkout-2-tooltips-save-new-guest': 'Maximum 50 guests',
  'checkout-2-form-hint-full-name': 'As in Passport/Official ID Card (without title/special characters)',
  'checkout-2-form-full-name-placeholder': 'Full name',
  'checkout-2-attach-file-upload-fail': 'Upload file fail',
  'checkout-2-attach-file-upload-fail-press-try-again': 'Please try agian.',
  'checkout-2-send-email-and-sms-traveller': 'We will send confirmation to this email and phone number.',
  'checkout-2-send-email-and-sms-booker': 'We will send confirmation to this email and phone number.',
  'checkout-2-arrival-time-title': 'Arrival information',
  'checkout-2-arrival-time-check-in': 'Check-in:',
  'checkout-2-arrival-time-description': 'Let the property know your planned arrival time.',
  'checkout-2-arrival-time-property-local-time': 'Property local time',
  'checkout-2-booker-for-other-employee-title': 'Booker for other employee',
  'checkout-2-booker-for-other-employee-sub-title': 'Please select checkbox to retrieve employee data.',
  'checkout-2-addtional-traveller-field-place-holder': 'Enter',
  'checkout-2-full-name-invalid-not-exist-company': 'Guest name not exist in your company. Please check and try again.',
  'checkout-2-full-name-invalid-duplicate': 'This guest already been selected. Please check and try again.',
  'checkout-2-full-name-invalid-credit-terms-off': 'Guest not allow to use credit terms.',
  'checkout-2-full-name-invalid-over-lap': 'Guest already have a booking in this period.',
  'checkout-2-full-name-invalid-restrict': 'This guest cannot book the accommodations in this destination due to company’s policy.',
  'checkout-2-full-name-invalid-no-approval': 'Guest has no supervisor email, please contact call center +66(0)2-020-2351.',
  'checkout-2-full-name-invalid-no-full-name': 'This guest has no full name, please contact call center +66(0)2-020-2351.',
  'checkout-2-over-budget-travel-policy': 'Guest has special budget limit in this destination THB {budget} /room/night',
  'checkout-2-over-budget': 'Guest has budget limit THB {budget} /room/night',
  'checkout-2-over-co-budget': 'Guest has budget limit for booking with 2 guests at THB {budget} /room/night.',

  // checkout 3
  'checkout-3-tooltip-label-diff': 'ต่างกันอย่างไร ?',
  'checkout-3-tooltip-label-work': 'ทำงาน',
  'checkout-3-tooltip-label-leisure': 'ท่องเที่ยว',
  'checkout-3-tooltip-desc-work': 'จองทริปทำงานสำหรับผู้เดินทางติดต่อธุรกิจได้อย่างง่ายดาย',
  'checkout-3-tooltip-desc-leisure': 'ค้นหาที่พักยอดเยี่ยมสำหรับทริปทุกรูปแบบ โดยการจองดังกล่าวจะไม่เชื่อมโยงกับบัญชีชองบริษัท',

  'checkout-3-label-custom-payment-paynow-topic': 'Select payment date',
  'checkout-3-label-select-payment-method': 'Select payment method',
  'checkout-3-label-custom-payment-paynow': 'Pay now',
  'checkout-3-label-custom-payment-paylater': 'Pay later',
  'checkout-3-label-custom-payment-paylater-sub-title': 'Book now, pay on ',
  'checkout-3-label-credit-card-infomation': 'Enter your card information',
  'checkout-3-label-tax-invoice-infomation': 'Tax Invoice/​Receipt Information',
  'checkout-3-label-month': 'Month',
  'checkout-3-label-year': 'Year',
  'checkout-3-label-card-number': 'Credit/debit card no.',
  'checkout-3-label-card-name': 'Card holder name',
  'checkout-3-label-card-expire-date': 'Expiry date',
  'checkout-3-label-card-cvv': 'CVC/CVV',
  'checkout-3-label-book-now': 'Book now,',
  'checkout-3-label-pay-on': 'Payment date for credit/debit card',
  'checkout-3-label-valid-until': 'Your credit card must valid until',
  'checkout-3-label-payment-detail': 'Payment details',
  'checkout-3-label-payment-multi-detail': 'Payment information',
  'checkout-3-label-payment-added-credit-card': 'Payment date for credit/debit card will be',
  'checkout-3-label-payment-added-pay-on': 'Payment date for credit/debit card',
  'checkout-3-label-payment-will-be': 'will be',

  'checkout-3-label-payment-credit-terms-tax-info': 'Tax invoice/Receipt information - Credit terms',
  'checkout-3-label-payment-credit-terms-tax-info-booker': 'Your Tax invoice/Receipt information - Credit terms',
  'checkout-3-label-payment-credit-terms-tax-info-co-booker': 'Co-booker Tax invoice/​Receipt information - Credit terms',
  'checkout-3-label-payment-credit-card-tax-info': 'Tax invoice/​Receipt information - Credit/debit card',
  'checkout-3-label-payment-true-money-tax-info': 'Tax invoice/​Receipt information - TrueMoney Wallet',
  'checkout-3-label-payment-tax-description-true-money': 'Tax invoice/​Receipt information - TrueMoney Wallet',
  'checkout-3-label-payment-qr-code-tax-info': 'Tax invoice/​Receipt information - QR Code',
  'checkout-3-label-payment-e-wallet-tax-info': 'Tax invoice/​Receipt information - E-Wallet',
  'checkout-3-label-payment-pay-at-counter-tax-info': 'Tax invoice/​Receipt information - Pay at Counter',
  'checkout-3-label-payment-im-banking-tax-info': 'Tax invoice/​Receipt information - Internet/Mobile Banking',

  'checkout-3-label-payment-tax-description-credit-term': 'Tax invoice/​Receipt information - Credit terms',
  'checkout-3-label-payment-tax-description': 'Tax invoice/​Receipt information - Credit/debit card',
  'checkout-3-label-multi-payment-info-edit-budget': 'Edit budget',
  'checkout-3-label-multi-payment-main-info': 'Pay with ',
  'checkout-3-label-multi-payment-extra-info': 'Pay with ',
  'checkout-3-label-multi-payment-info-credit-card': 'credit/debit card',
  'checkout-3-label-multi-payment-info-true-money': 'trueMoney wallet',
  'checkout-3-label-multi-payment-info-personal-fleet': 'personal fleet card',
  'checkout-3-label-multi-payment-info-personal-fleet-additional': 'personal fleet card',
  'checkout-3-label-multi-payment-info-corporate-fleet': 'corporate fleet card',
  'checkout-3-label-multi-payment-info-credit-terms': 'credit terms',
  'checkout-3-label-multi-payment-change-payment': 'Change payment',
  'checkout-3-label-night': 'night',
  'checkout-3-label-dot': '.',
  'checkout-3-label-multi-payment-info-budget-not-found': 'Do you have a budget limit?',
  'checkout-3-label-multi-payment-info-add-budget': 'Add budget',
  'checkout-3-label-multi-payment-info-reset': 'Reset',
  'checkout-3-label-multi-payment-info-not-reach-grand-total': 'Amount must be at least THB',
  'checkout-3-label-multi-payment-info-exceed-total-price': 'Amount exceed total price, maximum THB',
  'checkout-3-label-multi-payment-exceed-fleet-card': 'Amount exceed your card balance amount, maximum THB',

  'checkout-3-label-multi-payment-info-exceed-budget-limit': 'Amount exceed your budget limit, maximum THB',
  'checkout-3-label-multi-payment-info-exceed-budget-remaining': 'Amount exceed your remaining budget, maximum THB',
  'checkout-3-label-multi-payment-share-budget-least-booker': 'Your amount must be at least THB',
  'checkout-3-label-multi-payment-info-exceed-budget-limit-co-booker': 'Amount exceed co-booker budget limit, maximum THB',
  'checkout-3-label-multi-payment-info-exceed-budget-remaining-co-booker': 'Amount exceed co-booker remaining budget, maximum THB',
  'checkout-3-label-multi-payment-share-budget-least-co-booker': 'Co-booker mount must be at least THB',

  'checkout-3-label-credit-terms-info-title': 'Your credit terms information',
  'checkout-3-label-credit-terms-info-title-co-booker': 'Co-booker credit terms information',
  'checkout-3-label-credit-terms-info-desc': 'We will process to issue invoice to your company as per credit terms agreed.',
  'checkout-3-label-credit-terms-info-desc-co-booker': 'We will process to issue invoice to co-booker company as per credit terms agreed.',
  'checkout-3-label-credit-card-info-title': 'Credit/debit card information',
  'checkout-3-label-credit-terms-info-co-booker-email': 'Co-booker :',

  'checkout-3-label-credit-terms-info-traveller-title': 'Credit terms information for guest',
  'checkout-3-label-credit-terms-info-traveller-email': 'Guest',

  'checkout-3-label-desc-credit-term': 'You have select Credit Term as payment method.',
  'checkout-3-label-sub-desc-credit-term': 'We will process to issue invoice to your company as per Credit Terms agreed.',
  'checkout-3-label-fund-code': 'Company Reference Code (Optional)',
  'checkout-3-label-cost-center': 'Cost Center',
  'checkout-3-label-set-default': 'Use your cost center',
  'checkout-3-label-cost-center-name': 'Cost Center Name',
  'checkout-3-placeholder-cost-center': 'Enter Cost Center here',
  'checkout-3-placeholder-cost-center-name': 'Enter Cost Center Name here',
  'checkout-3-form-cost-center-required': 'Please enter ',
  'checkout-3-form-cost-center-name-required': 'Please enter ',
  'checkout-3-form-cost-center-name-invalid': '{text} is incorrect. Please enter {text} again.',
  'checkout-3-label-cost-center-dropdown': 'Please select ',
  'checkout-3-label-internal-order-dropdown': 'Please select ',
  'checkout-3-form-dropdown-placeholder': 'Select',
  'checkout-3-form-dropdown-required': 'Please select',
  'checkout-3-form-free-text-placeholder': 'Enter',
  'checkout-3-form-free-text-required': 'Please enter',
  'checkout-3-form-attachment-required': 'Please attach file.',

  'checkout-3-placeholder-card-number': '●●●● ●●●● ●●●● ●●●●',
  'checkout-3-placeholder-card-name': 'Card holder name',
  'checkout-3-placeholder-card-cvv': 'CVC/CVV',
  'checkout-3-placeholder-fund-code': 'Enter company reference code here',
  'checkout-3-placeholder-expire-date': 'dd/yy',

  'checkout-3-form-require-card-number': 'Please enter card number',
  'checkout-3-form-invalid-card-number': 'Card number is incorrect. Please check and try it again.',
  'checkout-3-form-invalid-card-number-not-support': 'The card you entered cannot be used for this payment.',
  'checkout-3-form-require-card-name': 'Please enter name on card',
  'checkout-3-form-invalid-card-name': 'Name on card must input in english only.',
  'checkout-3-form-require-card-cvv': 'Please enter CVC/CVV number.',
  'checkout-3-form-invalid-card-cvv': ' CVV number is incorrect. Please check and try it again.',
  'checkout-3-form-require-card-exp-date': 'Please enter card expiry date',
  'checkout-3-form-invalid-card-exp-date': 'Card expire date invalid.',
  'checkout-3-form-invalid-card-expire-pay-on': 'Cannot use this card due to the card expires before payment date',
  'checkout-3-require-tax-address': 'Please select tax invoice or receipt information',

  'checkout-3-error-cannot-create-booking': 'Your reservation is failed.<br/>Please try it again.',
  'checkout-3-error-limit-room': 'Your right for reservation has changed.<br/>Please check and try it again.',
  'checkout-3-error-limit-budget': 'Your budget limit has changed.<br/>Please check and try it again.',
  'checkout-3-address-edit-failure-title': 'Update tax infomation fail.',
  'checkout-3-error-cannot-get-dropdown-list': 'Get tax address list fail.',
  'checkout-3-default-dropdown': 'Please Select',
  'checkout-3-error-supervisor-email-invalid': 'Sorry, we cannot process your booking. Please contact call center to verify your supervisor email.<br/>Call center : +66(0) 2-020-2351',
  'checkout-3-error-credit-term-not-allow': 'Credit Terms not allowed for your reservation. Please contact call center for more information.<br/> Call center: +66(0) 2-020-2351',
  'checkout-3-error-multi-payment-not-allow': 'Sorry, you don\'t have a permission to book accommodations over your budget. Please contact call center for more information. <br/> Call center: +66(0) 2-020-2351',
  'checkout-3-error-credit-term-over-trip-budget': 'Credit Terms Amount Exceeds Approved Trip Budget<br>The approved trip budget is THB {totalTripBudget}.<br>Please adjust the credit terms amount or select another hotel and try again.',

  'checkout-3-true-money-title': 'TrueMoney Wallet information',
  'checkout-3-true-money-payment': 'ชำระเงินผ่านบัญชีทรูมันนี่',
  'checkout-3-true-money-payment-recheck': 'Add enough money before making a payment',
  'checkout-3-true-money-phone-no': 'TrueMoney Wallet phone number',
  'checkout-3-true-money-phone-no-empty': 'Please enter TrueMoney Wallet phone number.',
  'checkout-3-true-money-phone-pattern': 'Please enter a valid phone number.',
  'checkout-3-true-money-box-text-1': 'Payment date for TrueMoney Wallet',
  'checkout-3-true-money-box-text-2': 'will be',
  'checkout-3-true-money-true-point-short': 'ทุกการใช้จ่าย 25 บาท รับ 1 ทรูพอยท์',
  'checkout-3-require-payment-method': 'กรุณาเลือกช่องทางการชำระเงิน',
  'checkout-3-true-money-note': 'หมายเหตุ',
  'checkout-3-true-money-note-0': 'มูลค่าชำระทุก 25 บาท สำหรับการชำระเงินด้วย ทรูมันนี่ วอลเล็ท ได้รับ 1 ทรูพอยท์ ต่อ 1 รายการ ต่อ 1 หมายเลขบัตรประชาชน',
  'checkout-3-true-money-note-1': 'ลูกค้าจะได้รับทรูพอยท์ ภายใน 30 วันทำการหลังจากสั่งสินค้าผ่าน https://traveltogether.ascendtravel.com และจ่ายด้วย ทรูมันนี่ วอลเล็ท โดยจำกัดสิทธิ์ 100 ทรูพอยท์ / 1 บัตรประชาชน ตลอดระยะเวลาแคมเปญ',
  'checkout-3-true-money-note-2': 'รายการส่งเสริมการขายนี้ ดำเนินการโดยบริษัท ทรูมันนี่ จำกัด',
  'checkout-3-true-money-note-3': 'หากมีข้อสงสัย กรุณาติดต่อ TrueMoney Customer Care 1242 ตลอด 24 ชั่วโมง',
  'checkout-3-label-main-payment': 'Main payment',
  'checkout-3-label-additional-payment': 'Extra payment by yourself',
  'checkout-3-label-place-holder-payment': 'Please select payment method...',
  'checkout-3-label-additional-payment-error': 'Please select payment method.',
  'checkout-3-label-approximate-price-in': 'Approximate price in',

  'checkout-3-qr-code-title': 'QR Code',
  'checkout-3-e-wallet-title': 'E-Wallet',
  'checkout-3-im-banking-title': 'Internet/Mobile Banking',
  'checkout-3-im-banking-payment-channel': 'Mobile Banking / Internet Banking',
  'checkout-3-pay-at-counter-title': 'Pay at Counter',
  'checkout-3-pay-at-counter-bank-counter': 'Bank Counter',
  'checkout-3-pay-at-counter-other-counter': 'Other Counter',

  'checkout-3-payment-method-line1': 'We will inform you of payment methods on the next page.',
  'checkout-3-payment-method-line2': 'Please complete payment within 15 minutes to avoid cancellation of your booking.',
  'checkout-3-payment-method-line2-30': 'Please complete payment within 30 minutes to avoid cancellation of your booking.',
  'checkout-3-payment-method-line3-2c2p': 'Payments to Ascend Travel are processed by 2C2P SERVICE.',
  'checkout-3-payment-method-line3-123': 'Payments to Ascend Travel are processed by 123 SERVICE.',

  'checkout-3-payment-method-remark-line1': 'Additional service fees may be charged when you pay at the counter. (Additional service fees are non-refundable)',
  'checkout-3-payment-method-remark-line2': 'After completing payment You will receive a booking confirmation email within 2 hours. If you do not receive the email in the specified time, please contact',
  'checkout-3-payment-method-remark-line2-call-center': 'Call Center : +66(0) 2-020-2351',
  'checkout-3-payment-method-remark-line2-or': 'or',
  'checkout-3-payment-method-remark-line2-line': 'Line Official Account : @AscendTravel',

  'checkout-3-warning-please-make-payment': 'Please make payment within 15 minutes',
  'checkout-3-warning-please-make-payment-30': 'Please make payment within 30 minutes',
  'checkout-3-warning-avoid-cancellation': 'to avoid cancellation of your booking.',
  'checkout-3-warning-press': 'Please press',
  'checkout-3-warning-confirm-to-book': '"Confirm to book"',
  'checkout-3-warning-to-proceed': 'to proceed.',

  'checkout-3-payment-channel': 'Payment Channels',
  'checkout-3-payment-method': 'Payment Method',
  'checkout-3-payment-method-remark-title': 'Remark',

  // billing address component
  'checkout-3-label-billing-infomation': 'Bill To Information',
  'checkout-3-billing-address-name': 'Bill To',
  'checkout-3-billing-address-name-placeholder': 'Input Bill to Name/Surname',
  'checkout-3-billing-address-phone': 'Contact Number',
  'checkout-3-billing-address-phone-placeholder': '0XXXXXXXXX',
  'checkout-3-billing-address-address': 'Bill to Address',
  'checkout-3-billing-address-address-address-placeholder': 'Input bill to address here',

  'checkout-3-billing-validation-required-name': 'Please input bill to name',
  'checkout-3-billing-validation-required-phone': 'Please input contact number',
  'checkout-3-billing-validation-required-address': 'Please input bill to address',
  'checkout-3-billing-validation-invalid-name': 'Bill to name must be a-z A-Z',
  'checkout-3-billing-validation-invalid-phone': 'Contact number must be 0-9, 9 or 10 digits only',
  'checkout-3-billing-validation-invalid-address': 'Please input bill to address',

  'checkout-3-require-internal-order': 'Please enter ',
  'checkout-3-require-billing-address': 'Please select billing address',
  'checkout-3-billing-dialog-delete-button': 'Delete',
  'checkout-3-billing-delete-success': 'Delete Successful',
  'checkout-3-billing-delete-failure': 'Delete Failure',
  'checkout-3-billing-failure-text-try-again': 'Please try agian.',
  'checkout-3-billing-add': 'add billing address',
  'checkout-3-billing-edit': 'edit billing address',
  'checkout-3-billing-confirm-delete-msg': 'Are you sure you want to delete this information?',
  'checkout-3-billing-confirm-cancel-editing': 'You have not finished {dataType} yet. Do you want to leave without finishing?',

  'checkout-3-attach-file-title': 'File Attachment',
  'checkout-3-attach-file-choose-button': 'File Attachment',
  'checkout-3-attach-file-guide': 'Can attach up to 5 files and must be .jpg, .pdf, .png, .msg, .eml maximum size 2 MB only.',

  'checkout-3-attach-file-validation-invalid-file-type': 'Cannot support file format you have attached. You can attached file format .jpg, .pdf, .png, .msg, .eml only.',
  'checkout-3-attach-file-validation-file-size-overflow': 'The attachment size exceeds the allowable limit. You can attached file maximum size 2 MB only.',
  'checkout-3-attach-file-validation-file-not-attached': 'Please attach file.',

  'search-popup-checkbox-label': 'Do not show this message again',
  'popup-warning-session-expire': 'Your session will expire almost immediately.<br/>Please click OK to renew your session.',

  // Approval action
  'approval-action-success-approve': 'Approve reservation successfully.',
  'approval-action-success-reject': 'Rejected reservation successfully.',
  'approval-action-after-done': 'Cannot approve/reject reservation.',
  'approval-action-after-done-desc': 'Because you have already approved/rejected or traveller already check-in.',
  'approval-action-after-cancel': 'Cannot approve/reject reservation.',
  'approval-action-after-cancel-desc': 'Because booker has already cancelled this booking.',
  'approval-action-fail-service': 'Process is not successful.',
  'approval-action-fail-service-desc': 'Please try again.',
  'approval-action-thankyou-1': 'Thank you for your trust in using Ascend Travel\'s services.',
  'approval-action-thankyou-2': 'You can contact us via Call Center +66(0) 2-020-2351.',
  'approval-action-btn-home': 'Go to home',
  'approval-action-btn-approval-list': 'Go to approval',
  'approval-action-unable-approval': 'You cannot approve or reject booking.',
  'approval-action-unable-approval-detail': 'Please check your approval list at menu "Approval".',
  'approval-action-unable-approval-or-reject-detail': 'You cannot confirm or reject booking.',
  'approval-cancellation-credit-card': `Cancellation fee charge to card holder's credit/debit card`,


  'notify_accept_terms_conditions': 'ฉันยอมรับเงื่อนไข / I accept those conditions.',
  'notify_accept_terms_conditions_validation_accept': 'กรุณายอมรับเงื่อนไข / Please accept terms and condition.',

  // Krung sri
  'notify_accept_terms_conditions_message_krungsri': 'I acknowledge and agree that I will attach the form approved by the authorized person in order to book hotel for “work” In this case, invoices shall be issued by Ascend Travel to your Company. However, I agree and acknowledge that within 7 days of the Company’s request, I will make a payment for the cost and expenses charged by Ascend Travel to the Company if I didn’t check-in without reasonable reasons. For the booking for “leisure”, I pay by myself.',

  // Osotspa
  'notify_accept_terms_conditions_message_osotspa': 'I hereby agree to always comply with these booking terms and conditions.',

  'rating-header': 'What did you think of',
  'rating-check-in': 'Check-in',
  'rating-check-out': 'Check-out',
  'rating-star-1': 'Awful',
  'rating-star-2': 'Disappointing',
  'rating-star-3': 'Satisfactory',
  'rating-star-4': 'Good',
  'rating-star-5': 'Excellent',
  'rating-submit': 'Submit Review',
  'rating-error-select-satisfaction': 'Please select your satisfaction.',
  'rating-message-thankyou': 'Thank You for your review.<br/>Your feedback will help the hotel to improve and helps other travellers make the right decision.',
  'rating-header-animal': 'Have you seen any of these following creepy things?',
  'rating-summarize-header-1': 'Title of your review',
  'rating-summarize-placeholder-1': 'Summarize your visit or highlight an interesting detail',
  'rating-summarize-header-2': 'Your review',
  'rating-summarize-placeholder-2': 'Tell people about your experience: your room, location, amenties?',
  'rating-summarize-error': 'Please summarize your visit or highlight an interesting detail.',
  'rating-img-error': 'The file exceeds 2 MB.',
  'hide-name': 'Hide my name',
  'rating-photo-header': 'Do you have photos to share?',
  'rating-photo-subtitle': 'Maximum 5 Photos. File can be .png, jpeg or .jpg with maximum file size 2 MB.',

  // Banner promotion
  'banner-topic': 'Today\'s Deals',
  'banner-sub-topic': 'Exclusive promotions, discounts, and special offers just for you.',
  'banner-book-period': 'Book Period',
  'banner-stay-period': 'Stay Period',
  'banner-btn-book': 'Book',

  // Confirmation supplier
  'confirmation-supplier-email-reject': 'Please input your name to reject reservation from Ascend Travel',
  'confirmation-supplier-email-confirm': 'Please input your name to confirm reservation from Ascend Travel',
  'confirmation-supplier-email-confirm-title': 'Confirmed by',
  'confirmation-supplier-email-confirm-title-error': 'Please input Confirmed by',
  'confirmation-supplier-email-confirm-confirm-number': 'Confirmation Number (Optional)',
  'confirmation-supplier-email-reject-title': 'Rejected by',
  'confirmation-supplier-email-reject-title-error': 'Pease input Rejected by',
  'confirmation-supplier-email-reject-reason': 'Reason',
  'confirmation-supplier-email-reject-reason-error': 'Please input Reason',
  'confirmation-supplier-email-reject-topic-title': 'Please input your name to reject reservation from Ascend Travel',
  'confirmation-supplier-email-confirm-topic-title': 'Please input your name to confirm reservation from Ascend Travel',
  'confirmation-supplier-email-confirm-status-success': 'You have confirmed booking reservation from Ascend Travel',
  'confirmation-supplier-email-reject-status-success': 'You have rejected booking reservation from Ascend Travel',
  'confirmation-supplier-email-already': 'Because you have already confirmed/rejected.',
  'confirmation-supplier-email-placeholder-confirmed-by': 'Name/Surname',
  'confirmation-supplier-email-placeholder-confirmation-number': 'Confirmation Number',
  'confirmation-supplier-email-placeholder-rejected-by': 'Name/Surname',
  'confirmation-supplier-email-placeholder-reason': 'Reason to Reject',

  // Promotion
  'promotion-promotion-code-title': 'Promotion Code',
  'promotion-promotion-code-error': 'Please input Promotion Code',
  'promotion-promotion-code-button-submit': 'Submit',
  'promotion-promotion-code-topic-title': 'Please input Promotion Code',
  'promotion-promotion-code-error-invalid-message': 'Promotion code is invalid',
  'promotion-promotion-code-error-used-message': 'Promotion code has already used',
  'promotion-thankyou-title1': 'Your Booking No.',
  'promotion-thankyou-title2': 'is in progress',
  'promotion-thankyou-description': 'You will receive email confirmation again.',
  'promotion-promotion-code-error-invalid-link': 'This link has been removed from system.',
  'promotion-promotion-code-error-use-full': 'Sorry, this promotion code has been fully used already. ',
  'promotion-thankyou-status-timeout-title': 'Please contact call center to check your booking',
  'promotion-thankyou-status-timeout-text': "There was an error while processing your booking. Call center +66 (0)2-020-2351",

  // Condition
  'condition-selling-price-in-budget-title': 'Room price has changed as the following details.',
  'condition-selling-price-over-budget': 'The price exceeds your budget.',
  'condition-selling-price-in-budget-column': 'Room Type,Original Price per night,New Price per night',
  'condition-limit-room-title': 'Your booking condition is limited to a maximum of ${var} rooms.',
  'condition-cancellation-policy-title': 'The cancellation policy has changed as the following details.',
  'condition-cancellation-policy-column': 'Room Type,New Cancellation Policy',
  'condition-cancellation-policy-baht': 'If you cancel after ${var}, THB ${var} cancellation fees will be charged.',
  'condition-cancellation-policy-non-refundable': 'Non-refundable in any cases of cancellation',
  'condition-cancellation-policy-free-of-charge': 'Free Cancellation if cancellation is before ${var}.',
  'condition-free-cancellation': 'Free Cancellation',
  'condition-cancellation-policy-pay-now': 'Payment condition has changed <br/> from the original payment date of ${var}<br/> to be pay now.',
  'condition-cancellation-policy-pay-later': 'Payment condition has changed <br/> from the original payment date of today<br/> to ${var}.',
  'condition-cancelltaion-policy-pay-later-from-to': 'Payment condition has changed <br/> from the original payment date of ${var}<br/> to ${var}.',
  'condition-offer-type-title': 'Room condition has changed as the following details',
  'condition-offer-type-column': 'Room Type,Original Details,New Details',
  'condition-no-available-room-title': 'There is no available room in your preferred period.',
  'condition-button-accept': 'Accept',
  'condition-button-back-to-search': 'Back to Search',
  'condition-offer-type-breakfast-include': 'Breakfast Included',
  'condition-offer-type-breakfast-not-include': 'No Breakfast',
  'condition-aad-userid-not-exist': 'User not found',
  'condition-user-not-active-or-not-approve': 'User is inactive',
  'condition-period-overlaps-title': 'The selected period overlaps with the existing booking.',
  'condition-period-overlaps-description': 'You already have a booking in this period.',
  'condition-period-overlaps-share-budget-description': 'You or your co-booker already have a booking in this period.',
  'condition-restrict-destination-title': 'You cannot book the accommodations in this destination.',
  'condition-restrict-destination-description': 'This accommodation cannot be reserved at the destination which is in your working area. Please click OK and make a new selection.',
  'condition-restrict-destination-co-booker-title': 'You cannot book the accommodations in this destination.',
  'condition-restrict-destination-co-booker-description': 'Your company or co-booker company does not allow to book the accommodations in the selected destination.',
  'condition-some-guest-not-exist-in-your-comany': 'Some guest not exist in your company.',
  'condition-some-guest-not-allow-to-use-credit-terms': 'Some guest not allow to use credit terms.',
  'condition-some-guest-already-have-a-booking-in-this-period': 'Some guest already have a booking in this period.',
  'condition-some-guest-has-no-supervisor-email': 'Some guest has no supervisor email, please contact call center +66(0)2-020-2351.',

  // Mice
  'mice-quotation-title': 'Partner with us for the best solution.',
  'mice-quotation-sub-title': 'Please tell us about your event, we will be in touch with you shortly.',
  'mice-quotation-placeholder-dropdown': 'Please select service type',
  'mice-quotation-destination': 'Destination',
  'mice-quotation-start-date': 'Start Date',
  'mice-quotation-end-date': 'End Date',
  'mice-quotation-attendees': 'Attendees',
  'mice-quotation-budget': 'Budget (THB)',
  'mice-quotation-special-request': 'Special request',
  'mice-quotation-contact-title': 'Contact Information',
  'mice-quotation-contact-name': 'Contact Name',
  'mice-quotation-contact-company': 'Company Name',
  'mice-quotation-contact-phone': '0XXXXXXXXX',
  'mice-quotation-contact-email': 'email@mail.com',
  'mice-quotation-description-service': 'If you need additional services, please select the main service and specify more details in the additional field below.',
  'mice-quotation-description-date': 'If you cannot define the service date, you can just specify the period in the additional field below.',
  'mice-quotation-warning-placeholder-dropdown': 'Please select service type.',
  'mice-quotation-warning-contact-name': 'Please enter your name.',
  'mice-quotation-warning-zero-budget': 'Budget must be greater than 0 baht.',
  'mice-quotation-warning-zero-attendees': 'Attendees must be greater than 0.',
  'mice-quotation-warning-contact-company': 'Please enter your company name.',
  'mice-quotation-warning-contact-phone': 'Please enter your contact number.',
  'mice-quotation-warning-contact-email': 'Please enter your email.',
  'mice-quotation-button-submit': 'Submit information',
  'mice-quotation-popup-sent': 'Information has been sent!<br/> We will get back to you shortly',
  'mice-quotation-popup-fail': 'Sorry, something went wrong.<br/> Please try again',
  'mice-our-service-heading': 'Our Services',
  'mice-our-service-seminar': 'Seminar Management',
  'mice-our-service-seminar-sub-title': '(Seminar Management / MICE)',
  'mice-our-service-team-building': 'Team Building',
  'mice-our-service-team-building-sub-title': '(Team Building / Camp Project / Rally)',
  'mice-our-service-group-tour': 'Group Tour',
  'mice-our-service-group-tour-sub-title': '(Group Tour / Incentive Group)',
  'mice-our-service-party': 'Party and Event',
  'mice-our-service-party-sub-title': '(Staff Party / Private Party / Merit-making Ceremony)',
  'mice-our-service-csr': 'CSR Activity',
  'mice-our-service-csr-sub-title': '',
  'mice-our-service-private-jet': 'Private Jet',
  'mice-our-service-private-jet-sub-title': '',
  'mice-our-service-car-rental': 'Car Rental',
  'mice-our-service-car-rental-sub-title': '',
  'mice-our-service-ticket': 'Ticket & Visa Service',
  'mice-our-service-ticket-sub-title': '',
  'mice-benefit-title-easy': 'Easy',
  'mice-benefit-easy': 'Fill in all information in one place.',
  'mice-benefit-title-convenience': 'Convenience',
  'mice-benefit-convenience': 'Anywhere, Anytime, Any devices.',
  'mice-benefit-title-stop-service': 'One Stop Service',
  'mice-benefit-stop-service': 'Integrate all services to support all your business type.',
  'mice-benefit-title-professional': 'Professional',
  'mice-benefit-professional': 'Take care by experienced teams to make your perfect trip.',
  'mice-service-choice-tile': 'Partner with us for the best solution',
  'mice-service-choice-sub-title': 'with full services made convenient for bookings everywhere seamlessly. It\'s Free, Fast & Easy.',
  'mice-service-choice-button': 'Click here',
  'mice-service-gallery-title': 'Gallery',
  'mice-validation-pattern-contact-number': 'Contact number must be 0-9, 9-10 digits.',
  'mice-validation-pattern-email': 'Your email is incorrect. Please check and try it again.',

  'booking-cannot-be-processed-error-header': 'The booking cannot be processed',
  'booking-cannot-be-processed-error': 'Please try again.',
  'system-error': 'System error. Please try again.',

  // Dialog Switch Company
  'dialog-switch-company-title': 'Change company to',
  'dialog-switch-company-sub-title': 'For work purpose traveling, your condition will depend on the company setting.',
  'dialog-switch-company-payment-method': 'Payment method',
  'dialog-switch-company-budget': 'Budget per room per night',
  'dialog-switch-company-co-budget': 'Budget per room per night<br/>for 2 persons',
  'dialog-switch-company-budget-per-month': 'Budget per month',
  'dialog-switch-company-budget-per-year': 'Budget per year',
  'dialog-switch-company-tax-address': 'Tax Invoice',
  'dialog-switch-company-allow': 'Allow',
  'dialog-switch-company-allow-credit-terms': 'credit terms',
  'dialog-switch-company-allow-corporate-fleet': 'corporate fleet card',
  'dialog-switch-company-not-allow': 'not allowed',
  'dialog-switch-company-not-allow-credit-terms': 'for your reservation.',
  'dialog-switch-company-not-allow-corporate-fleet': 'Corporate fleet card not allow for your reservation',
  'dialog-switch-company-booking-under': 'If you want to make a booking under',
  'dialog-switch-company-credit-card': ', you can book and pay by credit/debit card.',
  'dialog-switch-company-warning': 'May be changed by your selection at payment step.',
  'dialog-switch-company-limit-room': 'No. of room per booking',
  'dialog-switch-company-room': 'room',
  'dialog-switch-company-multi-payment': 'Book over budget and pay for the exceeding amount by your own',
  'dialog-switch-company-share-budget': 'Share budget with another staff',
  'dialog-switch-company-limit-budget-warning': 'Your budget may vary according to the destination and period of stay.',
  'dialog-switch-company-for': 'for',
  'unlimited-budget': 'Unlimited',

  // Product Review
  'product-review-title': 'Guest Reviews',
  'product-review': 'Review',
  'product-review-date': 'Reviewed on',
  'product-review-order-by-review-date': 'Most recent',
  'product-review-order-by-rating-desc': 'Rating high to low',
  'product-review-order-by-rating-asc': 'Rating low to high',
  'product-review-image': 'Photo from guest',
  'product-review-anonymous': 'Anonymous',

  // Dialog Budget suggestion
  'dialog-budget-suggestion-title': 'Budget limit',
  'dialog-budget-suggestion-desc': 'Your budget will be calculated to fill amount for each payment method, and saved for your next reservation. You can modify budget anytime in this step.',
  'dialog-budget-suggestion-form-btn-submit': 'Apply budget',
  'dialog-budget-suggestion-form-btn-cancel': 'Cancel',
  'dialog-budget-suggestion-label-budget': 'Budget per room per night',
  'dialog-budget-suggestion-form-require-budget': 'Please enter budget per room per night.',
  'dialog-budget-suggestion-form-exceed-limit-budget': 'Amount exceed limit, maximum THB 1,000,000.',

  // Dialog Tax Address
  'dialog-tax-address-title-add-mode': 'Add new Tax Invoice/​Receipt Information',
  'dialog-tax-address-title-edit-mode': 'Tax Invoice/​Receipt Information',

  // Filter Dropdown
  'filter-dropdown-no-results-match': 'No results match',
  'form-autocomplete-no-result': 'No results found',

  // Dialog
  'dialog-close': 'Close',
  'dialog-cancel': 'Cancel',
  'dialog-confirm': 'Confirm',

  // Dropdown
  'default-dropdown': 'Please Select',

  // Dialog confirm close
  'dialog-confirm-close-title': 'Leave this page',
  'dialog-confirm-close-desc': 'Do you want to leave this page without saving?',
  'dialog-confirm-close-cancel': 'Cancel',
  'dialog-confirm-close-confirm': 'Yes, leave',
  'dialog-confirm-change-search': 'Change search',
  'dialog-confirm-change-continue-share-budget': 'Continue',
  'dialog-confirm-cancel-share-budget': 'Cancel share budget',

  // Dialog confirm delete
  'dialog-confirm-delete-title': 'Delete',
  'dialog-confirm-delete-cancel': 'Cancel',
  'dialog-confirm-delete-confirm': 'Delete',

  // Dialog confirm delete address
  'dialog-confirm-delete-address-desc': 'Do you want to delete this address?',

  // PDPA
  'pdpa-btn-accept': 'Accept',
  'pdpa-title': 'Terms of Use and Privacy Policy',
  'pdpa-term-of-use': 'Terms of Use',
  'pdpa-privacy-notice': 'Privacy Policy',
  'cookies-policy': 'Cookies Policy',

  // Dialog Consent
  'dialog-consent-to-website': 'We’re taking you to website',
  'dialog-consent-requesting-permission': 'website is requesting permission to do the following:',
  'dialog-consent-basic-information': 'Access your basic information',
  'dialog-consent-contact-information': 'Access your contact information',
  'dialog-consent-allow': 'Allow',
  'dialog-consent-dont-allow': 'Don’t allow',
  'dialog-consent-full-name-etc': `Includes first name, last name and any other information you've shared with Ascend Travel.`,

  // Badge or Notices
  'sanitized-stay': 'Sanitized Stay',
  'sanitized-stay-hover': 'Hygiene and sanitizing standards to ensure the protection of your health and safety',
  'year-of-build-badge': 'Newly built {yyyy}',
  'year-of-renovated-badge': 'New renovated {yyyy}',
  'security-standard-badge': 'Safety Standard',
  'security-standard-badge-hover': 'Hotel property has undergone special inspections for safety standard.',

  // Dialog Budget Available
  'dialog-budget-pay-option': 'You can pay by another options if you are still want to book a room.',
  'dialog-budget-pay-exceeding-option': 'You can pay for the exceeding amount by another options if you are still want to book a room.',
  'dialog-budget-cannot-share-budget-co-booker': 'You cannot share budget with co-booker',
  'dialog-budget-due-to': ' due to ',

  // Dialog Cancel Share Budget
  'dialog-cancel-share-budget-text': 'Do you want to cancel share budget?',
  'dialog-cancel-share-budget-sub-text': 'If you cancel share budget, you can only book accommodations under your budget limit.',

  //Dialog PIN
  'dialog-set-pin-header': 'Set Pin',
  'dialog-confirm-set-pin-header': 'Confirm PIN code',
  'dialog-set-pin-sub-header': 'Set a 6-digit number to maintain account security.',
  'dialog-set-pin-sub-header-2': 'Use PIN code for credit terms payment processing to your company.',
  'dialog-confirm-pin-booking-header': 'Entering the PIN code.',
  'dialog-confirm-pin-booking-sub-header': 'Please enter a 6-digit PIN code for credit terms payment processing to your company.',
  'dialog-confirm-pin-booking-forgot-pin': 'Forgot your PIN?',
  'dialog-confirm-pin-booking-set-new-pin': 'Click to set a new PIN.',
  'dialog-alert-set-pin-title': 'Your account does not have a PIN code set up yet.',
  'dialog-alert-set-pin-description': 'To ensure safety for credit terms payment to the company. Please set a new PIN by yourself.<br> Go to the menu: <b>My Account > Account Security > Set PIN<b>',
  'dialog-alert-btn-confirm-set-pin': 'Set PIN',
  'pin-code-incorrect': 'The PIN code is incorrect.',
  'set-pin-not-matched': 'PIN code is not match with confirm PIN code. Please check and try it again.',
  'pin-too-weak': 'The PIN code is too simple. Please choose a more secure PIN.',
  'pin-remaining-attempts': 'The PIN code is incorrect. Please try again. You have {x} remaining attempts before your PIN code gets locked.',
  'pin-locked': 'Your PIN code has been locked. Please reset your PIN code or contact: Call Center: +66(0) 2-020-2351 / Line Official Account: @AscendTravel',
  'otp-title': 'Identity Verification',
  'otp-select-channel': 'Please select one of the options below to verify your identity.',
  'otp-send-to': 'Send verification code to',
  'otp-resend': 'Resend verification code',
  'otp-reference': 'Ref.: ',
  'otp-code-incorrect': 'The verification code is incorrect.',
  'otp-last-attempts': 'The verification code is incorrect. You have 1 remaining attempt. If you enter the verification code incorrectly again, your account will be temporarily locked.',
  'otp-remaining-attempts': 'The verification code is incorrect. Please try again. You have {x} remaining attempts before your account gets locked.',
  'otp-try-another-way': 'Try another way',
  'setup-pin-success': 'PIN code has been successfully set.',
  'dialog-otp-verify-sub-header': 'We have sent a verification code to',
  'dialog-otp-verify-email-sub-header': 'Please check your email and enter the verification code below within 15 minutes after receiving the email.',
  'dialog-otp-verify-sms-sub-header': 'Please check your message and enter the verification code below within 15 minutes after receiving the message.',
  'email': 'Email',
  'phone': 'Phone',
  'account-locked': 'Your account has been locked. Due to exceeding the allowed number of incorrect verification code entries. For unlocking, please contact: Call Center: +66(0) 2-020-2351 / Line Official Account: @AscendTravel',
  'session-expired': 'Session expired. Please try again.',

  // Dialog Phone
  'dialog-set-phone-header': 'Enter your phone',
  'dialog-set-phone-sub-header': 'Please provide the phone number you want to link to your account.',
  'dialog-set-phone-label-phone-number': 'Phone',
  'dialog-set-phone-require-mobile-number': 'Please enter phone number.',
  'dialog-set-phone-invalid-mobile-number': 'Please enter a valid phone number.',
  'change-phone-success': 'The phone number has been successfully linked to the account.',

  // Budget Limit
  'budget-limit-special-budget-for-destination': 'Special budget for this destination',
  'budget-limit-special-budget-for-poi': 'You budget depends on the selected destination.',
  'budget-limit-special-budget-for-poi-new': 'Your new budget depends on the selected destination.',
  'budget-limit-normal-budget': 'Normal budget',
  'budget-limit-tittle': 'You have special budget limit for this destination',
  'budget-limit-detail': 'You have special budget limit on some days, view your budget limit details as below.',
  'budget-limit-detail-poi': 'You have special budget limit on some days and some areas, view your budget limit details as below.',
  'budget-limit-dialog-detail-poi': 'You have special budget limit for this destination, view your budget limit details as below.',
  'budget-limit-detail-bottom-poi': 'Budget per room per night depends on the selected destination.',
  'budget-limit-net-budget': 'Budget limit/room/night for this period',
  'budget-limit-more-detail': 'More details',
  'budget-limit-day-check-in': 'Stay date',
  'budget-limit-budget-per-night': 'Budget per night',
  'budget-limit-sum-budget-per-night': 'Total budget per night',
  'budget-limit-budget-special': 'Special budget',
  'budget-limit-budget-per-night-per-room': 'Budget per room per night',
  'budget-limit-for-search': 'for the selected period',
  'budget-limit-and': 'and',
  'budget-limit-for': 'For',
  'budget-limit-unlimited': 'Unlimited',
  'budget-limit-view-detail': 'View Details',
  'budget-limit-unlimited-share-budget': 'Your new budget/room/night is unlimited.',
  'budget-limit-share-budget': 'Your new budget limit <strong>{x}</strong> /room/night.',
  'budget-limit-share-budget-title': 'You have shared budget with co-booker and have special budget limit for this destination',
  'budget-limit-share-budget-detail': 'You have special budget limit on some days, view your budget limit details as below.',
  'budget-limit-booker-budget': 'Your budget',
  'budget-limit-co-booker-budget': 'Your co-booker budget',
  'budget-limit-co-booker-budget-new-tab': 'Your co-booker budget',
  'budget-limit-total-budget': 'Total budget per night',
  'budget-limit-normal-budget-booker': 'Your normal budget',
  'budget-limit-normal-budget-co-booker': 'Your co-booker budget',
  'budget-limit-applied-co-budget': '**There is a budget limit for booking with 2 guests.',

  // My Budget
  'my-budget-title': 'User permission & budget',
  'my-budget-under': '{companyName}',
  'my-budget-user-permission-detail-title': 'User permission',
  'my-budget-budget-detail-title': 'Budget',
  'my-budget-month': 'Month',
  'my-budget-budget-used': 'Spending',
  'my-budget-budget-per-month-remaining': ' Remaining budget/month',
  'my-budget-budget-per-year-remaining': 'Remaining budget/year',
  'my-budget-badge-per-month-remaining': 'Remaining budget for',
  'my-budget-badge-per-monht-used': 'You have already spent',
  'my-budget-badge-per-year-remaining': 'Remaining budget for',
  'my-budget-badge-per-year-used': 'You have already spent',
  'my-budget-year': 'Year',

  // Share Budget Code
  'share-budget-code-title': 'Generate share budget code',
  'share-budget-code-content-title': 'Share budget code is the reference code for main booker to share budget with you.',
  'share-budget-code-generate-code': 'Generate code',
  'share-budget-code-copy-code': 'Copy code',
  'share-budget-code-text': 'Share budget code',
  'share-budget-code-generate-code-link': 'Generate new code',
  'share-budget-code-copied': 'Copied to clipcoard ',
  'share-budget-code-description': 'Code will expire in 24 hours. If you generate new code, the previous code will expire immediately.',
  'share-budget-code-select-company-label': 'Please select company',
  'share-budget-code-defalut-company': 'Select company',
  'share-budget-code-not-allow': 'Your company not allow to share budget.',

  // Dialog Share Budget
  'dialog-share-budget-title': 'Share budget with co-booker',
  'dialog-share-budget-sub-title': 'You need to get an approval from a co-booker before you make a booking.',
  'dialog-share-budget-code-ref': 'Share budget code',
  'dialog-share-budget-code-ref-change': 'Change',
  'dialog-share-budget-co-booker-email': 'Co-booker email',
  'dialog-share-budget-co-booker-company': 'Co-booker company',
  'dialog-share-budget-co-booker-company-address': 'Co-booker Tax Invoice/​Receipt information',
  'dialog-share-budget-error-code-ref-require': 'Please enter share budget code.',
  'dialog-share-budget-error-code-ref-incorrect': 'Share budget code is incorrect. Please check and try again.',
  'dialog-share-budget-error-code-ref-expired': 'Share budget code is expired. Please check and try again.',
  'dialog-share-budget-error-code-ref-yourself': 'You cannot share budget with yourself.',
  'dialog-share-budget-error-code-ref-not-allow-feature': 'Share budget code is expire due to your company or co-booker company not allow to share budget.',
  'dialog-share-budget-gen-code-link': 'Co-booker can generate share budget code at',
  'dialog-share-budget-copy-link': 'Copy link',
  'dialog-share-budget-copy-link-to-clipboard': 'Copied to clipboard',
  'dialog-share-budget-company': '',
  'dialog-share-budget-tax-id': 'Tax ID',
  'dialog-share-budget-confirm-share-budget': 'Confirm',

  //Dialog payment
  'dialog-payment-title': 'Payment will be separated into 2 payment methods',
  'dialog-payment-sub-title': 'Please select payment method',
  'dialog-payment-main-payment': 'Main payment',
  'dialog-payment-extra-payment': 'Extra payment by yourself',

  // Form Share Budget
  'form-share-budget-title': 'Payment details',
  'form-share-budget-title-multi': 'Payment information',
  'form-share-budget-credit-terms-title': 'Pay with credit terms',
  'form-share-budget-credit-terms-booker': 'Charge to main booker',
  'form-share-budget-credit-terms-co-booker': 'Charge to co-booker',
  'form-share-budget-other-payment': 'Pay with ',
  'form-share-budget-other-payment-credit-terms': 'Pay with credit terms',
  'form-share-budget-other-payment-credit-card': 'credit/debit card',
  'form-share-budget-other-payment-true-money': 'truemoney wallet',
  'form-share-budget-other-payment-personal-fleet': 'personal fleet card',

  'room-special-request-optional': ' - Optional',
  'room-special-request-sub-title': `We'll send your request right after you book. Special request cannot be guaranteed and may incur charges, but the property will do its best to meet your wish.`,
  'room-special-preferred-room': 'Preferred Room',
  'room-special-request-non-smoke-room': 'Non-smoking Room',
  'room-special-request-smoke-room': 'Smoking Room',
  'room-special-preferred-bed': 'Preferred Bed',
  'room-special-request-large-bed': 'Large Bed',
  'room-special-request-twin-bed': 'Twin Bed',
  'room-special-more-special-requests': 'More special requests',
  'room-special-request-high-floor-room': 'High Floor Room',
  'room-special-request-connecting-room': 'Connecting Room',
  'room-special-request-quiet-room': 'Quiet Room',
  'room-special-others-en': 'Others (Please enter in English only)',
  'room-special-others': 'Others',
  'room-special-more-request': 'More requests',

  // Dialog Information Cart
  'dialog-information-cart-title': 'Important Information',
  'dialog-information-cart-sub-title': 'Please read this important information. Some condition has been updated and may incur additional charges as follows.',
  'dialog-information-cart-accept-condition': 'I accept the conditions above.',
  'dialog-information-cart-accept-condition-required': 'Please accept the conditions in order to process booking.',

  // Fleet Card Information
  'fleet-card-status-active': 'Active',
  'fleet-card-status-inactive': 'Inactive',
  'fleet-card-status-expired': 'Expired',
  'fleet-card-type-corporate': 'Corporate',
  'fleet-card-type-personal': 'Personal',
  'fleet-card-information-card-personal': 'Personal',
  'fleet-card-no-expiration-date': 'No expiration date',
  'fleet-card-information-fleet-card-type-all': 'All fleet card',
  'fleet-card-information-fleet-card-type-corporate': 'Corporate fleet card',
  'fleet-card-information-fleet-card-type-personal': 'Personal fleet card',
  'fleet-card-information-title': 'Fleet card',
  'fleet-card-information-register': 'Add new card',
  'fleet-card-information-fleet-card-no-label': 'Fleet card no.',
  'fleet-card-information-redeemed-amount': 'Used',
  'fleet-card-information-balance-amount': 'Balance',
  'fleet-card-information-information-label': 'Fleet card information',
  'fleet-card-information-status-label': 'Status',
  'fleet-card-information-type-label': 'Type',
  'fleet-card-information-company-label': 'Company',
  'fleet-card-information-expiration-label': 'Expiration date',
  'fleet-card-information-topup': 'Top up',
  'fleet-card-information-transfer': 'Transfer',
  'fleet-card-information-no-fleet-title': 'There is no fleet card added to your account',
  'fleet-card-information-no-fleet-description-1': 'If you already have fleet card, please click “Add new card” to start using your card.',
  'fleet-card-information-no-fleet-description-2': 'If you want to buy fleet card, please contact us.',
  'fleet-card-information-no-fleet-company-title': 'There is no corporate fleet card added to your account.',
  'fleet-card-information-no-fleet-personal-title': 'There is no personal fleet card added to your account.',

  // Dialog Fleet Card Top Up
  'dialog-fleet-card-top-up-title': 'We will open online top up service soon!',
  'dialog-fleet-card-top-up-sub-title-1': 'If you want to buy more fleet card, please contact us.',

  // Dialog Fleet Card Register
  'dialog-fleet-card-register-title': 'Add new fleet card',
  'dialog-fleet-card-register-fleet-card-no-label': 'Fleet card no.',
  'dialog-fleet-card-register-fleet-card-no-error-required': 'Please enter fleet card number.',
  'dialog-fleet-card-register-secret-code-label': 'Secret code',
  'dialog-fleet-card-register-secret-code-tooltip': `Secret code is an authentication number to add fleet card to your account. Secret code will be sent to the specified email of the card buyer.`,
  'dialog-fleet-card-register-secret-code-error-required': 'Please enter secret code.',
  'dialog-fleet-card-register-fleet-card-no-or-secret-code-invalid': 'Fleet card number or secret code is incorrect.',
  'dialog-fleet-card-register-fleet-card-is-already-registered': 'This card is already added.',
  'dialog-fleet-card-register-fleet-card-is-expired': 'This card is already expired.',
  'dialog-fleet-card-register-fleet-card-cannot-register-company': 'This card cannot be added to this company account.',

  // Fleet Card Transaction History
  'fleet-card-transaction-history-title': 'Transaction history',
  'fleet-card-transaction-history-filter-date-all': 'All',
  'fleet-card-transaction-history-filter-by': 'Transaction type',
  'fleet-card-transaction-history-filter-all': 'All',
  'fleet-card-transaction-history-filter-redeem': 'Redeem',
  'fleet-card-transaction-history-filter-transfer-withdrawal': 'Transfer withdrawal',
  'fleet-card-transaction-history-filter-transfer-deposit': 'Transfer deposit',
  'fleet-card-transaction-history-filter-refund': 'Refund',
  'fleet-card-transaction-history-date': 'Transaction date',
  'fleet-card-transaction-history-activity': 'Activity',
  'fleet-card-transaction-history-balance': 'Balance',
  'fleet-card-transaction-history-text-redeem': 'Redeem Booking ID',
  'fleet-card-transaction-history-text-transfer-withdrawal': 'Transfer to',
  'fleet-card-transaction-history-text-transfer-deposit': 'Transfer from',
  'fleet-card-transaction-history-text-refund': 'Refund Booking ID',
  'fleet-card-transaction-history-no-transaction': 'No Transaction',

  // Dialog Fleet Card Register Complete
  'dialog-fleet-card-register-complete-title': 'Fleet card successfully added',
  'dialog-fleet-card-register-complete-fleet-card-no-label': 'Card no.',
  'dialog-fleet-card-register-complete-fleet-card-type-label': 'Card type',
  'dialog-fleet-card-register-complete-company-label': 'Company',
  'dialog-fleet-card-register-complete-expiration-date-label': 'Expiration date',
  'dialog-fleet-card-register-complete-amount-label': 'Amount',

  // Checkout 3 Fleet Card
  'checkout-3-fleet-card-title': 'Fleet card information',
  'checkout-3-personal-fleet-title': 'Personal fleet card information',
  'checkout-3-corporate-fleet-title': 'Corporate Fleet card information',
  'checkout-3-fleet-card-no-you-account': 'There is no fleet card registered on your account',
  'checkout-3-fleet-card-no-you-account-sub-1': 'If you already have fleet card, please register to start using your card at menu <i class="icon-fleet"> <b>Fleet Card</b>',
  'checkout-3-fleet-card-no-you-account-sub-2': 'If you want to buy fleet card, please contact call center +66(0) 2-020-2351',
  'checkout-3-fleet-card-no-you-account-sub-3': 'or Line Official Account',
  'checkout-3-fleet-card-information': 'Payment date for fleet card',
  'checkout-3-fleet-card-payment-date': 'will be',
  'checkout-3-personal-fleet': 'Personal',
  'checkout-3-fleet-card-cannot-selected-error': 'Your balance is insufficient. Please select a different payment method or select another fleet card.',
  'checkout-3-fleet-card-cannot-selected-error-multi': 'Amount exceed your budget limit. Please select a different payment method.',
  // Dialog Fleet Card Transfer
  'dialog-fleet-card-transfer-default-dropdown': 'Select fleet card no.',
  'dialog-fleet-card-transfer-title': 'Transfer balance',
  'dialog-fleet-card-transfer-sub-title': 'You can transfer fleet balance to the card which is the same card type and under the same company. The card must not have an expiration date.',
  'dialog-fleet-card-transfer-fleet-card-no-from-label': 'From fleet card no.',
  'dialog-fleet-card-transfer-fleet-card-no-to-label': 'To fleet card no.',
  'dialog-fleet-card-transfer-fleet-card-no-to-note': 'The list of cards will only show cards that can transfer funds.',
  'dialog-fleet-card-transfer-amount-label': 'Amount',
  'dialog-fleet-card-transfer-amount-error-required': 'Please enter amount.',
  'dialog-fleet-card-transfer-amount-error-insufficient': 'Insufficient balance.',
  'dialog-fleet-card-transfer-amount-error-exceed': 'Amount exceeds the limit on the card.',

  // Dialog Fleet Card Transfer Complete
  'dialog-fleet-card-transfer-complete-title': 'Your funds transfer is complete',
  'dialog-fleet-card-transfer-complete-from-label': 'Transfer from card no.',
  'dialog-fleet-card-transfer-complete-to-label': 'To card no.',
  'dialog-fleet-card-transfer-complete-amount-label': 'Amount',

  // Dialog Fleet Card Register Fail
  'dialog-fleet-card-register-fail-title': 'Could not add card',
  'dialog-fleet-card-register-fail-sub-title': 'Please try again.',

  // Dialog Fleet Card Transfer Fail
  'dialog-fleet-card-transfer-fail-title': 'Could not transfer fleet balance',
  'dialog-fleet-card-transfer-fail-sub-title': 'Please try again.',

  'payment-channel-type-multi-payment': 'Multi-payment',
  'payment-channel-type-credit-terms': 'Credit Terms',
  'payment-channel-type-credit-card': 'Credit/Debit Card',
  'payment-channel-type-true-money': 'TrueMoney Wallet',
  'payment-channel-type-personal-fleet': 'Personal Fleet Card',
  'payment-channel-type-corporate-fleet': 'Corporate Fleet Card',
  'payment-channel-type-fleet-card': 'Fleet Card',
  'payment-channel-type-personal-payment': '* Personal Payment *',
  'payment-channel-type-qr-code': 'QR Code',
  'payment-channel-type-e-wallet': 'E-Wallet',
  'payment-channel-type-im-banking': 'Internet/Mobile Banking',
  'payment-channel-type-pay-at-counter': 'Counter',

  'payment-method-collapse': 'View less',
  'payment-method-expanse': 'Show all payment methods',

  'check-in-check-out': 'Check-in/Check-out',
  'check-in-from': 'Check-in from',
  'check-out-until': 'Check-out until',
  'check-out-from': 'Check-out from',
  'early-late-check-in': 'You may request early or late check-in during booking, subject to availability.',
  'product-description': 'About the property',

  'product-images': 'View all photos',
  'all-photos': 'All photos',

  // product item
  'product-hot-deal': 'Hot Deal!',
  'product-promotion-last-minute': '<strong>Last Minute Sale!</strong>',
  'product-discount-percent': 'Discount <strong>{price}</strong>%',
  'product-discount-amount': 'Discount <strong>THB {price}</strong>',

  'info-window-content-navigate': 'Get directions',

  // arrival time
  'arrival-time-i-dont-know': 'I don’t know',
  'arrival-time-0000-0100': '00:00 - 01:00',
  'arrival-time-0100-0200': '01:00 - 02:00',
  'arrival-time-0200-0300': '02:00 - 03:00',
  'arrival-time-0300-0400': '03:00 - 04:00',
  'arrival-time-0400-0500': '04:00 - 05:00',
  'arrival-time-0500-0600': '05:00 - 06:00',
  'arrival-time-0600-0700': '06:00 - 07:00',
  'arrival-time-0700-0800': '07:00 - 08:00',
  'arrival-time-0800-0900': '08:00 - 09:00',
  'arrival-time-0900-1000': '09:00 - 10:00',
  'arrival-time-1000-1100': '10:00 - 11:00',
  'arrival-time-1100-1200': '11:00 - 12:00',
  'arrival-time-1200-1300': '12:00 - 13:00',
  'arrival-time-1300-1400': '13:00 - 14:00',
  'arrival-time-1400-1500': '14:00 - 15:00',
  'arrival-time-1500-1600': '15:00 - 16:00',
  'arrival-time-1600-1700': '16:00 - 17:00',
  'arrival-time-1700-1800': '17:00 - 18:00',
  'arrival-time-1800-1900': '18:00 - 19:00',
  'arrival-time-1900-2000': '19:00 - 20:00',
  'arrival-time-2000-2100': '20:00 - 21:00',
  'arrival-time-2100-2200': '21:00 - 22:00',
  'arrival-time-2200-2300': '22:00 - 23:00',
  'arrival-time-2300-2400': '23:00 - 24:00',
  'arrival-time-0000-0100-the-next-day': '00:00 - 01:00 (the next day)',
  'arrival-time-0100-0200-the-next-day': '01:00 - 02:00 (the next day)',

  'view-more': 'View more',
  'view-less': 'View less',

  //Modal Update Profile
  'positive-energy-title' : 'Find positive energy accommodation',
  'positive-energy-title-desc' : 'Simply provide your date of birth, and we will help you find accommodation that enhances positive energy by using numerology calculations.',
  'positive-energy-description' : 'The information regarding your date of birth and time of birth <strong>will be kept confidential and protected under The Personal Data Protection Act (PDPA).</strong> It will be used for recommending positive energy accommodations only and <strong>it does not affect search result.</strong> By submitting your information, you agree with <a class="link-hover-style" href="https://www.ascendtravel.com/privacy-policy?lang=en" target="_blank">Privacy Policy</a> of AscendTravel.com',
  'full-name-description' : 'Please enter in English only as in Passport/Official ID Card (without title/special characters).',
  'time-of-birth-label' : 'Time of birth',
  'time-of-birth-placeholder' : 'Select time of birth',
  'time-of-birth-option-unspecified' : 'Unknown',
  'time-of-birth-option-day' : 'Daytime (6:00 - 17:59 hrs.)',
  'time-of-birth-option-night' : 'Nighttime (18:00 - 05:59 hrs.)',
  'time-of-birth-day': 'Daytime',
  'time-of-birth-night': 'Nighttime',
  'positive-energy-btn-submit' : 'Search'
};



// WEBPACK FOOTER //
// ./src/translation/lang-en.ts